// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/img/mainImage.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/fontawesome-webfont.2b13baa7.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/fontawesome-webfont.e9955780.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/fontawesome-webfont.cf011583.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/fontawesome-webfont.8a7cb27d.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "#iefix&v=4.7.0" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.whatsapp-icon-div {
  /* border: 1px solid black; */
  top: 45%;
  left: .5cm;
  position: fixed;
  /* inset: 0; */
  z-index: 50;
  /* width: fit-content; */
  /* height: fit-content; */
  padding: .2cm;
  border-radius: 50%;
  background-color: #25d366;
  cursor: pointer;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.header {
  width: 90%;
  height: 17cm;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) bottom no-repeat;
  background-size: 250pt;
  position: relative;
  padding-top: 20px;
  background-color: #fff;
  background-attachment: scroll;
  background-position-y: 190px;
  /* border: 1px solid black; */
}

/*! tailwindcss v2.2.19 | MIT License | https://tailwindcss.com */
/*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */

/*! tailwindcss v2.2.19 | MIT License | https://tailwindcss.com */
/*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */
html {
  tab-size: 4;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji;
}

hr {
  height: 0;
  color: inherit;
}

abbr[title] {
  text-decoration: underline dotted;
}

b,
strong {
  font-weight: bolder;
}

code,
kbd,
pre,
samp {
  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo,
    monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

table {
  text-indent: 0;
  border-color: inherit;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}

button,
select {
  text-transform: none;
}

[type="button"],
[type="reset"],
[type="submit"],
button {
  -webkit-appearance: button;
}

::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

:-moz-focusring {
  outline: 1px dotted ButtonText;
}

:-moz-ui-invalid {
  box-shadow: none;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

summary {
  display: list-item;
}

blockquote,
dd,
dl,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
pre {
  margin: 0;
}

button {
  background-color: transparent;
  background-image: none;
}

fieldset,
ol,
ul {
  margin: 0;
  padding: 0;
}

ol,
ul {
  list-style: none;
}

html {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
    Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif,
    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  line-height: 1.5;
}

body {
  font-family: inherit;
  line-height: inherit;
}

*,
:after,
:before {
  box-sizing: border-box;
  border: 0 solid;
}

hr {
  border-top-width: 1px;
}

img {
  border-style: solid;
}

textarea {
  resize: vertical;
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  color: #9ca3af;
}

[role="button"],
button {
  cursor: pointer;
}

:-moz-focusring {
  outline: auto;
}

table {
  border-collapse: collapse;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

a {
  color: inherit;
  text-decoration: inherit;
}

button,
input,
optgroup,
select,
textarea {
  padding: 0;
  line-height: inherit;
  color: inherit;
}

code,
kbd,
pre,
samp {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    Liberation Mono, Courier New, monospace;
}

audio,
canvas,
embed,
iframe,
img,
object,
svg,
video {
  display: block;
  vertical-align: middle;
}

img,
video {
  max-width: 100%;
  height: auto;
}

[hidden] {
  display: none;
}

*,
:after,
:before {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
  --tw-ring-inset: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-blur: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-brightness: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-contrast: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-grayscale: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-hue-rotate: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-invert: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-saturate: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-sepia: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-drop-shadow: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  --tw-backdrop-blur: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-backdrop-brightness: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-backdrop-contrast: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-backdrop-grayscale: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-backdrop-hue-rotate: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-backdrop-invert: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-backdrop-opacity: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-backdrop-saturate: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-backdrop-sepia: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.container {
  width: 100%;
}

@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}

.sr-only {
  white-space: nowrap;
  border-width: 0;
}

.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.sticky {
  position: sticky;
}

.top-0 {
  top: 0;
}

.bottom-96 {
  bottom: 24rem;
}

.z-50 {
  z-index: 50;
}

.z-10 {
  z-index: 10;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.-mx-5 {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}

.-my-2 {
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.mt-12 {
  margin-top: 3rem;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.mr-5 {
  margin-right: 1.25rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mt-10 {
  margin-top: 2.5rem;
}

.-mr-2 {
  margin-right: -0.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.block {
  display: block;
}

.flex {
  display: flex;
}

.inline-flex {
  display: inline-flex;
}

.table {
  display: table;
}

.grid {
  display: grid;
}

.hidden {
  display: none;
}

.h-screen {
  height: 100vh;
}

.h-7 {
  height: 1.75rem;
}

.h-12 {
  height: 3rem;
}

.h-6 {
  height: 1.5rem;
}

.h-16 {
  height: 4rem;
}

.h-32 {
  height: 8rem;
}

.h-auto {
  height: auto;
}

.h-72 {
  height: 18rem;
}

.min-h-screen {
  min-height: 100vh;
}

.w-full {
  width: 100%;
}

.w-5\\/6 {
  width: 83.333333%;
}

.w-32 {
  width: 8rem;
}

.w-20 {
  width: 5rem;
}

.w-auto {
  width: auto;
}

.w-6 {
  width: 1.5rem;
}

.w-screen {
  width: 100vw;
}

.w-72 {
  width: 18rem;
}

.w-48 {
  width: 12rem;
}

.w-11 {
  width: 2.75rem;
}

.max-w-7xl {
  max-width: 80rem;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.border-collapse {
  border-collapse: collapse;
}

.cursor-pointer {
  cursor: pointer;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.flex-col {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.items-center {
  align-items: center;
}

.items-stretch {
  align-items: stretch;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.space-x-6> :not([hidden])~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-4> :not([hidden])~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-1> :not([hidden])~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.divide-y> :not([hidden])~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}

.overflow-auto {
  overflow: auto;
}

.overflow-hidden {
  overflow: hidden;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-md {
  border-radius: 0.375rem;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.border {
  border-width: 1px;
}

.border-2 {
  border-width: 2px;
}

.border-l-4 {
  border-left-width: 4px;
}

.border-orange {
  --tw-border-opacity: 1;
  border-color: rgba(246, 68, 1, var(--tw-border-opacity));
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.border-l-orange {
  --tw-border-opacity: 1;
  border-left-color: rgba(246, 68, 1, var(--tw-border-opacity));
}

.bg-orange {
  --tw-bg-opacity: 1;
  background-color: rgba(246, 68, 1, var(--tw-bg-opacity));
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));
}

.bg-pink {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 224, 229, var(--tw-bg-opacity));
}

.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgba(5, 150, 105, var(--tw-bg-opacity));
}

.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}

.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}

.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}

.p-2 {
  padding: 0.5rem;
}

.p-4 {
  padding: 1rem;
}

.p-3 {
  padding: 0.75rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.pr-40 {
  padding-right: 10rem;
}

.pt-1 {
  padding-top: 0.25rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.pb-3 {
  padding-bottom: 0.75rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pr-4 {
  padding-right: 1rem;
}

.pr-8 {
  padding-right: 2rem;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.align-middle {
  vertical-align: middle;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xxs {
  font-size: 0.6rem;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.font-medium {
  font-weight: 500;
}

.font-bold {
  font-weight: 700;
}

.text-orange {
  --tw-text-opacity: 1;
  color: rgba(246, 68, 1, var(--tw-text-opacity));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgba(209, 213, 219, var(--tw-text-opacity));
}

.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgba(156, 163, 175, var(--tw-text-opacity));
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgba(31, 41, 55, var(--tw-text-opacity));
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.filter {
  filter: var(--tw-filter);
}

.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
}

.backdrop-blur,
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-filter);
}

.play-zoom {
  animation: playzoom 1s infinite;
}

@keyframes playzoom {
  0% {
    background-position: 50%;
    transform: scale(1);
  }

  50% {
    background-position: 50%;
    transform: scale(1.2);
  }

  to {
    background-position: 50%;
    transform: scale(1);
  }
}

.btn.btn-circle {
  background-color: #f64401;
  border-radius: 50%;
  width: 60px;
  color: #fff;
  height: 60px;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px #f64401b3;
  outline: none;
  padding-top: 5px;
  border: 2px solid #fff;
}

.btn.btn-circle i {
  font-size: 32px;
}


@media only screen and (max-width : 768px) {
  .header {
    /* width: 50%; */
    background-size: 200pt;
    background-position-y: 130px;
    height: 15.5cm;

  }
}

/* 
@media (max-width: 768px) {
  .header {
    width: 90%;
    background-size: 200pt;
    height: 35vh;
    background-position-y: 120px;
  }
}

@media (max-width : 500px) {
  .header {
    width: 90%;
    background-size: 200pt;
    height: 100vh;
    background-position-y: 170px;
  }
} */

/* @media (min-height : 500px) {
  .header {
    width: 90%;
    background-size: 200pt;
    height: 80vh;
    background-position-y: 170px;
  }
}

@media (min-height : 900px) {
  .header {
    width: 90%;
    background-size: 200pt;
    height: 60vh;
    background-position-y: 170px;
  }
} */

.divTable {
  align-items: center;
  align-items: stretch;
  text-align: center;
  margin-top: 2.5cm;
}

.thChartDate {
  width: 120px;
  font-size: small;
  border: 1px solid #017ba0b4;
  padding: 20px;
}

.thChartDate,
.thChartHeader {
  height: 50px;
  text-align: center;
}

.thChartHeader {
  width: 65px;
  border: 1px solid #c3d0f0b4;
  top: 0;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}

@media (min-width: 768px) {
  .thChartHeader {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.headerDate {
  font-size: 0.6rem;
}

@media (min-width: 768px) {
  .headerDate {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.fontResult {
  font-size: 15px !important;
  font-weight: 700 !important;
}

.tdChartDate {
  width: 95px;
  padding: 0 4px;
}

.tdChartDate,
.thChartResult {
  height: 50px;
  border: 1px solid #c3d0f0b4;
  text-align: center;
}

.thChartResult {
  width: 75px;
}

.fontResultCustom {
  font-size: 15px;
  font-weight: 700;
}

.tdChartGreen {
  --tw-bg-opacity: 1;
  background-color: rgba(239, 68, 68, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  text-align: center;
}

.redList {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  color: red;
}

.tdChartRed {
  border: 1px solid #649afdaa;
  text-align: center;
}

.gameNameChart {
  margin-top: 1.25rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(246, 68, 1, var(--tw-text-opacity));
}

.gameNameDesc {
  margin: 0.25rem 0.25rem 1rem;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1rem;
}

@media (min-width: 768px) {
  .gameNameDesc {
    font-size: 0.9em;
  }
}

.viewChartFont {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

@media (min-width: 768px) {
  .viewChartFont {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.spanPannaUp {
  font-size: 0.75rem;
  line-height: 1rem;
}

.spanPannaCenter {
  text-align: inherit;
  vertical-align: middle;
}

div.divPanna {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.tdDate {
  font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
}

.dateDivLeft {
  font-size: 0.9em;
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}

@media (min-width: 768px) {
  .dateDivLeft {
    font-size: 0.6rem;
  }
}

.dateDivLeft {
  writing-mode: vertical-rl;
  text-orientation: upright;
}

.dateDivRight {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 0.6rem;
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}

@media (min-width: 768px) {
  .dateDivRight {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

.divBottomButtons> :not([hidden])~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.divBottomButtons {
  padding: 1.25rem;
}

.hangingButtons {
  position: fixed;
  left: 0.25rem;
}

.bounce,
.hangingButtons {
  margin-top: 0.75rem;
}

@keyframes bounce {

  0%,
  to {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

.bounce {
  animation: bounce 1s infinite;
}

.chartHeading {
  margin-top: 1.25rem;
  margin-bottom: 0.25rem;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgba(239, 68, 68, var(--tw-bg-opacity));
  padding: 0.75rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

@media (min-width: 768px) {
  .chartHeading {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

.gameNameRow {
  line-height: 47px !important;
  margin: 0.25rem;
  height: 3rem;
  border-width: 1px;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.025em;
  --tw-text-opacity: 1;
  color: rgba(246, 68, 1, var(--tw-text-opacity));
}

@media (min-width: 768px) {
  .gameNameRow {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.clsResultsTable {
  display: inline-block;
  vertical-align: middle;
  font-size: 0.6rem;
}

@media (min-width: 768px) {
  .clsResultsTable {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.divResultsTable {
  display: inline-block;
  vertical-align: middle;
}

.parentDiv {
  font-family: Lora, serif;
  margin: 1.5rem 0.25rem 2rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}

@media (min-width: 768px) {
  .parentDiv {
    margin-right: 8rem;
    margin-left: 8rem;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.titleDiv {
  margin-top: 1rem;
}

.center {
  padding-top: 1rem;
  text-align: center;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 600;
}

.feature_divider {
  margin: 0.75rem auto 2rem;
  height: 1px;
  width: 8rem;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
}

.divParagraph {
  margin: 2rem;
}

.paragraph {
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: justify;
  line-height: 1.5rem;
}

ul li {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: 1.5rem;
  text-align: justify;
}

.h2htp {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(246, 68, 1, var(--tw-text-opacity));
}

@media (min-width: 768px) {
  .h2htp {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

.auheading {
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(55, 65, 81, var(--tw-text-opacity));
}

@media (min-width: 768px) {
  .auheading {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

.autext {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

@media (min-width: 768px) {
  .autext {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(55, 65, 81, var(--tw-bg-opacity));
}

.hover\\:bg-orange:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(246, 68, 1, var(--tw-bg-opacity));
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgba(17, 24, 39, var(--tw-text-opacity));
}

.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-inset:focus {
  --tw-ring-inset: inset;
}

.focus\\:ring-white:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(255, 255, 255, var(--tw-ring-opacity));
}

@media (min-width: 640px) {
  .sm\\:ml-6 {
    margin-left: 1.5rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
}

@media (min-width: 768px) {
  .md\\:grid {
    display: grid;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

@media (min-width: 1024px) {
  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

/*!
 *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)
 */
@font-face {
  font-family: FontAwesome;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype"),
    format("svg");
  font-weight: 400;
  font-style: normal;
}

.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fa-lg {
  font-size: 1.33333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-fw {
  width: 1.28571429em;
  text-align: center;
}

.fa-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.fa-ul>li {
  position: relative;
}

.fa-li {
  position: absolute;
  left: -2.14285714em;
  width: 2.14285714em;
  top: 0.14285714em;
  text-align: center;
}

.fa-li.fa-lg {
  left: -1.85714286em;
}

.fa-border {
  padding: 0.2em 0.25em 0.15em;
  border: 0.08em solid #eee;
  border-radius: 0.1em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left {
  margin-right: 0.3em;
}

.fa.fa-pull-right {
  margin-left: 0.3em;
}

.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

.fa.pull-left {
  margin-right: 0.3em;
}

.fa.pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  animation: fa-spin 2s linear infinite;
}

.fa-pulse {
  animation: fa-spin 1s steps(8) infinite;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}

.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scaleX(-1);
}

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scaleY(-1);
}

:root .fa-flip-horizontal,
:root .fa-flip-vertical,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-rotate-90 {
  filter: none;
}

.fa-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.fa-stack-1x,
.fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: #fff;
}

.fa-glass:before {
  content: "\\f000";
}

.fa-music:before {
  content: "\\f001";
}

.fa-search:before {
  content: "\\f002";
}

.fa-envelope-o:before {
  content: "\\f003";
}

.fa-heart:before {
  content: "\\f004";
}

.fa-star:before {
  content: "\\f005";
}

.fa-star-o:before {
  content: "\\f006";
}

.fa-user:before {
  content: "\\f007";
}

.fa-film:before {
  content: "\\f008";
}

.fa-th-large:before {
  content: "\\f009";
}

.fa-th:before {
  content: "\\f00a";
}

.fa-th-list:before {
  content: "\\f00b";
}

.fa-check:before {
  content: "\\f00c";
}

.fa-close:before,
.fa-remove:before,
.fa-times:before {
  content: "\\f00d";
}

.fa-search-plus:before {
  content: "\\f00e";
}

.fa-search-minus:before {
  content: "\\f010";
}

.fa-power-off:before {
  content: "\\f011";
}

.fa-signal:before {
  content: "\\f012";
}

.fa-cog:before,
.fa-gear:before {
  content: "\\f013";
}

.fa-trash-o:before {
  content: "\\f014";
}

.fa-home:before {
  content: "\\f015";
}

.fa-file-o:before {
  content: "\\f016";
}

.fa-clock-o:before {
  content: "\\f017";
}

.fa-road:before {
  content: "\\f018";
}

.fa-download:before {
  content: "\\f019";
}

.fa-arrow-circle-o-down:before {
  content: "\\f01a";
}

.fa-arrow-circle-o-up:before {
  content: "\\f01b";
}

.fa-inbox:before {
  content: "\\f01c";
}

.fa-play-circle-o:before {
  content: "\\f01d";
}

.fa-repeat:before,
.fa-rotate-right:before {
  content: "\\f01e";
}

.fa-refresh:before {
  content: "\\f021";
}

.fa-list-alt:before {
  content: "\\f022";
}

.fa-lock:before {
  content: "\\f023";
}

.fa-flag:before {
  content: "\\f024";
}

.fa-headphones:before {
  content: "\\f025";
}

.fa-volume-off:before {
  content: "\\f026";
}

.fa-volume-down:before {
  content: "\\f027";
}

.fa-volume-up:before {
  content: "\\f028";
}

.fa-qrcode:before {
  content: "\\f029";
}

.fa-barcode:before {
  content: "\\f02a";
}

.fa-tag:before {
  content: "\\f02b";
}

.fa-tags:before {
  content: "\\f02c";
}

.fa-book:before {
  content: "\\f02d";
}

.fa-bookmark:before {
  content: "\\f02e";
}

.fa-print:before {
  content: "\\f02f";
}

.fa-camera:before {
  content: "\\f030";
}

.fa-font:before {
  content: "\\f031";
}

.fa-bold:before {
  content: "\\f032";
}

.fa-italic:before {
  content: "\\f033";
}

.fa-text-height:before {
  content: "\\f034";
}

.fa-text-width:before {
  content: "\\f035";
}

.fa-align-left:before {
  content: "\\f036";
}

.fa-align-center:before {
  content: "\\f037";
}

.fa-align-right:before {
  content: "\\f038";
}

.fa-align-justify:before {
  content: "\\f039";
}

.fa-list:before {
  content: "\\f03a";
}

.fa-dedent:before,
.fa-outdent:before {
  content: "\\f03b";
}

.fa-indent:before {
  content: "\\f03c";
}

.fa-video-camera:before {
  content: "\\f03d";
}

.fa-image:before,
.fa-photo:before,
.fa-picture-o:before {
  content: "\\f03e";
}

.fa-pencil:before {
  content: "\\f040";
}

.fa-map-marker:before {
  content: "\\f041";
}

.fa-adjust:before {
  content: "\\f042";
}

.fa-tint:before {
  content: "\\f043";
}

.fa-edit:before,
.fa-pencil-square-o:before {
  content: "\\f044";
}

.fa-share-square-o:before {
  content: "\\f045";
}

.fa-check-square-o:before {
  content: "\\f046";
}

.fa-arrows:before {
  content: "\\f047";
}

.fa-step-backward:before {
  content: "\\f048";
}

.fa-fast-backward:before {
  content: "\\f049";
}

.fa-backward:before {
  content: "\\f04a";
}

.fa-play:before {
  content: "\\f04b";
}

.fa-pause:before {
  content: "\\f04c";
}

.fa-stop:before {
  content: "\\f04d";
}

.fa-forward:before {
  content: "\\f04e";
}

.fa-fast-forward:before {
  content: "\\f050";
}

.fa-step-forward:before {
  content: "\\f051";
}

.fa-eject:before {
  content: "\\f052";
}

.fa-chevron-left:before {
  content: "\\f053";
}

.fa-chevron-right:before {
  content: "\\f054";
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-minus-circle:before {
  content: "\\f056";
}

.fa-times-circle:before {
  content: "\\f057";
}

.fa-check-circle:before {
  content: "\\f058";
}

.fa-question-circle:before {
  content: "\\f059";
}

.fa-info-circle:before {
  content: "\\f05a";
}

.fa-crosshairs:before {
  content: "\\f05b";
}

.fa-times-circle-o:before {
  content: "\\f05c";
}

.fa-check-circle-o:before {
  content: "\\f05d";
}

.fa-ban:before {
  content: "\\f05e";
}

.fa-arrow-left:before {
  content: "\\f060";
}

.fa-arrow-right:before {
  content: "\\f061";
}

.fa-arrow-up:before {
  content: "\\f062";
}

.fa-arrow-down:before {
  content: "\\f063";
}

.fa-mail-forward:before,
.fa-share:before {
  content: "\\f064";
}

.fa-expand:before {
  content: "\\f065";
}

.fa-compress:before {
  content: "\\f066";
}

.fa-plus:before {
  content: "\\f067";
}

.fa-minus:before {
  content: "\\f068";
}

.fa-asterisk:before {
  content: "\\f069";
}

.fa-exclamation-circle:before {
  content: "\\f06a";
}

.fa-gift:before {
  content: "\\f06b";
}

.fa-leaf:before {
  content: "\\f06c";
}

.fa-fire:before {
  content: "\\f06d";
}

.fa-eye:before {
  content: "\\f06e";
}

.fa-eye-slash:before {
  content: "\\f070";
}

.fa-exclamation-triangle:before,
.fa-warning:before {
  content: "\\f071";
}

.fa-plane:before {
  content: "\\f072";
}

.fa-calendar:before {
  content: "\\f073";
}

.fa-random:before {
  content: "\\f074";
}

.fa-comment:before {
  content: "\\f075";
}

.fa-magnet:before {
  content: "\\f076";
}

.fa-chevron-up:before {
  content: "\\f077";
}

.fa-chevron-down:before {
  content: "\\f078";
}

.fa-retweet:before {
  content: "\\f079";
}

.fa-shopping-cart:before {
  content: "\\f07a";
}

.fa-folder:before {
  content: "\\f07b";
}

.fa-folder-open:before {
  content: "\\f07c";
}

.fa-arrows-v:before {
  content: "\\f07d";
}

.fa-arrows-h:before {
  content: "\\f07e";
}

.fa-bar-chart-o:before,
.fa-bar-chart:before {
  content: "\\f080";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-camera-retro:before {
  content: "\\f083";
}

.fa-key:before {
  content: "\\f084";
}

.fa-cogs:before,
.fa-gears:before {
  content: "\\f085";
}

.fa-comments:before {
  content: "\\f086";
}

.fa-thumbs-o-up:before {
  content: "\\f087";
}

.fa-thumbs-o-down:before {
  content: "\\f088";
}

.fa-star-half:before {
  content: "\\f089";
}

.fa-heart-o:before {
  content: "\\f08a";
}

.fa-sign-out:before {
  content: "\\f08b";
}

.fa-linkedin-square:before {
  content: "\\f08c";
}

.fa-thumb-tack:before {
  content: "\\f08d";
}

.fa-external-link:before {
  content: "\\f08e";
}

.fa-sign-in:before {
  content: "\\f090";
}

.fa-trophy:before {
  content: "\\f091";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-upload:before {
  content: "\\f093";
}

.fa-lemon-o:before {
  content: "\\f094";
}

.fa-phone:before {
  content: "\\f095";
}

.fa-square-o:before {
  content: "\\f096";
}

.fa-bookmark-o:before {
  content: "\\f097";
}

.fa-phone-square:before {
  content: "\\f098";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-facebook-f:before,
.fa-facebook:before {
  content: "\\f09a";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-unlock:before {
  content: "\\f09c";
}

.fa-credit-card:before {
  content: "\\f09d";
}

.fa-feed:before,
.fa-rss:before {
  content: "\\f09e";
}

.fa-hdd-o:before {
  content: "\\f0a0";
}

.fa-bullhorn:before {
  content: "\\f0a1";
}

.fa-bell:before {
  content: "\\f0f3";
}

.fa-certificate:before {
  content: "\\f0a3";
}

.fa-hand-o-right:before {
  content: "\\f0a4";
}

.fa-hand-o-left:before {
  content: "\\f0a5";
}

.fa-hand-o-up:before {
  content: "\\f0a6";
}

.fa-hand-o-down:before {
  content: "\\f0a7";
}

.fa-arrow-circle-left:before {
  content: "\\f0a8";
}

.fa-arrow-circle-right:before {
  content: "\\f0a9";
}

.fa-arrow-circle-up:before {
  content: "\\f0aa";
}

.fa-arrow-circle-down:before {
  content: "\\f0ab";
}

.fa-globe:before {
  content: "\\f0ac";
}

.fa-wrench:before {
  content: "\\f0ad";
}

.fa-tasks:before {
  content: "\\f0ae";
}

.fa-filter:before {
  content: "\\f0b0";
}

.fa-briefcase:before {
  content: "\\f0b1";
}

.fa-arrows-alt:before {
  content: "\\f0b2";
}

.fa-group:before,
.fa-users:before {
  content: "\\f0c0";
}

.fa-chain:before,
.fa-link:before {
  content: "\\f0c1";
}

.fa-cloud:before {
  content: "\\f0c2";
}

.fa-flask:before {
  content: "\\f0c3";
}

.fa-cut:before,
.fa-scissors:before {
  content: "\\f0c4";
}

.fa-copy:before,
.fa-files-o:before {
  content: "\\f0c5";
}

.fa-paperclip:before {
  content: "\\f0c6";
}

.fa-floppy-o:before,
.fa-save:before {
  content: "\\f0c7";
}

.fa-square:before {
  content: "\\f0c8";
}

.fa-bars:before,
.fa-navicon:before,
.fa-reorder:before {
  content: "\\f0c9";
}

.fa-list-ul:before {
  content: "\\f0ca";
}

.fa-list-ol:before {
  content: "\\f0cb";
}

.fa-strikethrough:before {
  content: "\\f0cc";
}

.fa-underline:before {
  content: "\\f0cd";
}

.fa-table:before {
  content: "\\f0ce";
}

.fa-magic:before {
  content: "\\f0d0";
}

.fa-truck:before {
  content: "\\f0d1";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-plus:before {
  content: "\\f0d5";
}

.fa-money:before {
  content: "\\f0d6";
}

.fa-caret-down:before {
  content: "\\f0d7";
}

.fa-caret-up:before {
  content: "\\f0d8";
}

.fa-caret-left:before {
  content: "\\f0d9";
}

.fa-caret-right:before {
  content: "\\f0da";
}

.fa-columns:before {
  content: "\\f0db";
}

.fa-sort:before,
.fa-unsorted:before {
  content: "\\f0dc";
}

.fa-sort-desc:before,
.fa-sort-down:before {
  content: "\\f0dd";
}

.fa-sort-asc:before,
.fa-sort-up:before {
  content: "\\f0de";
}

.fa-envelope:before {
  content: "\\f0e0";
}

.fa-linkedin:before {
  content: "\\f0e1";
}

.fa-rotate-left:before,
.fa-undo:before {
  content: "\\f0e2";
}

.fa-gavel:before,
.fa-legal:before {
  content: "\\f0e3";
}

.fa-dashboard:before,
.fa-tachometer:before {
  content: "\\f0e4";
}

.fa-comment-o:before {
  content: "\\f0e5";
}

.fa-comments-o:before {
  content: "\\f0e6";
}

.fa-bolt:before,
.fa-flash:before {
  content: "\\f0e7";
}

.fa-sitemap:before {
  content: "\\f0e8";
}

.fa-umbrella:before {
  content: "\\f0e9";
}

.fa-clipboard:before,
.fa-paste:before {
  content: "\\f0ea";
}

.fa-lightbulb-o:before {
  content: "\\f0eb";
}

.fa-exchange:before {
  content: "\\f0ec";
}

.fa-cloud-download:before {
  content: "\\f0ed";
}

.fa-cloud-upload:before {
  content: "\\f0ee";
}

.fa-user-md:before {
  content: "\\f0f0";
}

.fa-stethoscope:before {
  content: "\\f0f1";
}

.fa-suitcase:before {
  content: "\\f0f2";
}

.fa-bell-o:before {
  content: "\\f0a2";
}

.fa-coffee:before {
  content: "\\f0f4";
}

.fa-cutlery:before {
  content: "\\f0f5";
}

.fa-file-text-o:before {
  content: "\\f0f6";
}

.fa-building-o:before {
  content: "\\f0f7";
}

.fa-hospital-o:before {
  content: "\\f0f8";
}

.fa-ambulance:before {
  content: "\\f0f9";
}

.fa-medkit:before {
  content: "\\f0fa";
}

.fa-fighter-jet:before {
  content: "\\f0fb";
}

.fa-beer:before {
  content: "\\f0fc";
}

.fa-h-square:before {
  content: "\\f0fd";
}

.fa-plus-square:before {
  content: "\\f0fe";
}

.fa-angle-double-left:before {
  content: "\\f100";
}

.fa-angle-double-right:before {
  content: "\\f101";
}

.fa-angle-double-up:before {
  content: "\\f102";
}

.fa-angle-double-down:before {
  content: "\\f103";
}

.fa-angle-left:before {
  content: "\\f104";
}

.fa-angle-right:before {
  content: "\\f105";
}

.fa-angle-up:before {
  content: "\\f106";
}

.fa-angle-down:before {
  content: "\\f107";
}

.fa-desktop:before {
  content: "\\f108";
}

.fa-laptop:before {
  content: "\\f109";
}

.fa-tablet:before {
  content: "\\f10a";
}

.fa-mobile-phone:before,
.fa-mobile:before {
  content: "\\f10b";
}

.fa-circle-o:before {
  content: "\\f10c";
}

.fa-quote-left:before {
  content: "\\f10d";
}

.fa-quote-right:before {
  content: "\\f10e";
}

.fa-spinner:before {
  content: "\\f110";
}

.fa-circle:before {
  content: "\\f111";
}

.fa-mail-reply:before,
.fa-reply:before {
  content: "\\f112";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-folder-o:before {
  content: "\\f114";
}

.fa-folder-open-o:before {
  content: "\\f115";
}

.fa-smile-o:before {
  content: "\\f118";
}

.fa-frown-o:before {
  content: "\\f119";
}

.fa-meh-o:before {
  content: "\\f11a";
}

.fa-gamepad:before {
  content: "\\f11b";
}

.fa-keyboard-o:before {
  content: "\\f11c";
}

.fa-flag-o:before {
  content: "\\f11d";
}

.fa-flag-checkered:before {
  content: "\\f11e";
}

.fa-terminal:before {
  content: "\\f120";
}

.fa-code:before {
  content: "\\f121";
}

.fa-mail-reply-all:before,
.fa-reply-all:before {
  content: "\\f122";
}

.fa-star-half-empty:before,
.fa-star-half-full:before,
.fa-star-half-o:before {
  content: "\\f123";
}

.fa-location-arrow:before {
  content: "\\f124";
}

.fa-crop:before {
  content: "\\f125";
}

.fa-code-fork:before {
  content: "\\f126";
}

.fa-chain-broken:before,
.fa-unlink:before {
  content: "\\f127";
}

.fa-question:before {
  content: "\\f128";
}

.fa-info:before {
  content: "\\f129";
}

.fa-exclamation:before {
  content: "\\f12a";
}

.fa-superscript:before {
  content: "\\f12b";
}

.fa-subscript:before {
  content: "\\f12c";
}

.fa-eraser:before {
  content: "\\f12d";
}

.fa-puzzle-piece:before {
  content: "\\f12e";
}

.fa-microphone:before {
  content: "\\f130";
}

.fa-microphone-slash:before {
  content: "\\f131";
}

.fa-shield:before {
  content: "\\f132";
}

.fa-calendar-o:before {
  content: "\\f133";
}

.fa-fire-extinguisher:before {
  content: "\\f134";
}

.fa-rocket:before {
  content: "\\f135";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-chevron-circle-left:before {
  content: "\\f137";
}

.fa-chevron-circle-right:before {
  content: "\\f138";
}

.fa-chevron-circle-up:before {
  content: "\\f139";
}

.fa-chevron-circle-down:before {
  content: "\\f13a";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-anchor:before {
  content: "\\f13d";
}

.fa-unlock-alt:before {
  content: "\\f13e";
}

.fa-bullseye:before {
  content: "\\f140";
}

.fa-ellipsis-h:before {
  content: "\\f141";
}

.fa-ellipsis-v:before {
  content: "\\f142";
}

.fa-rss-square:before {
  content: "\\f143";
}

.fa-play-circle:before {
  content: "\\f144";
}

.fa-ticket:before {
  content: "\\f145";
}

.fa-minus-square:before {
  content: "\\f146";
}

.fa-minus-square-o:before {
  content: "\\f147";
}

.fa-level-up:before {
  content: "\\f148";
}

.fa-level-down:before {
  content: "\\f149";
}

.fa-check-square:before {
  content: "\\f14a";
}

.fa-pencil-square:before {
  content: "\\f14b";
}

.fa-external-link-square:before {
  content: "\\f14c";
}

.fa-share-square:before {
  content: "\\f14d";
}

.fa-compass:before {
  content: "\\f14e";
}

.fa-caret-square-o-down:before,
.fa-toggle-down:before {
  content: "\\f150";
}

.fa-caret-square-o-up:before,
.fa-toggle-up:before {
  content: "\\f151";
}

.fa-caret-square-o-right:before,
.fa-toggle-right:before {
  content: "\\f152";
}

.fa-eur:before,
.fa-euro:before {
  content: "\\f153";
}

.fa-gbp:before {
  content: "\\f154";
}

.fa-dollar:before,
.fa-usd:before {
  content: "\\f155";
}

.fa-inr:before,
.fa-rupee:before {
  content: "\\f156";
}

.fa-cny:before,
.fa-jpy:before,
.fa-rmb:before,
.fa-yen:before {
  content: "\\f157";
}

.fa-rouble:before,
.fa-rub:before,
.fa-ruble:before {
  content: "\\f158";
}

.fa-krw:before,
.fa-won:before {
  content: "\\f159";
}

.fa-bitcoin:before,
.fa-btc:before {
  content: "\\f15a";
}

.fa-file:before {
  content: "\\f15b";
}

.fa-file-text:before {
  content: "\\f15c";
}

.fa-sort-alpha-asc:before {
  content: "\\f15d";
}

.fa-sort-alpha-desc:before {
  content: "\\f15e";
}

.fa-sort-amount-asc:before {
  content: "\\f160";
}

.fa-sort-amount-desc:before {
  content: "\\f161";
}

.fa-sort-numeric-asc:before {
  content: "\\f162";
}

.fa-sort-numeric-desc:before {
  content: "\\f163";
}

.fa-thumbs-up:before {
  content: "\\f164";
}

.fa-thumbs-down:before {
  content: "\\f165";
}

.fa-youtube-square:before {
  content: "\\f166";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-youtube-play:before {
  content: "\\f16a";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitbucket-square:before {
  content: "\\f172";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-long-arrow-down:before {
  content: "\\f175";
}

.fa-long-arrow-up:before {
  content: "\\f176";
}

.fa-long-arrow-left:before {
  content: "\\f177";
}

.fa-long-arrow-right:before {
  content: "\\f178";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-female:before {
  content: "\\f182";
}

.fa-male:before {
  content: "\\f183";
}

.fa-gittip:before,
.fa-gratipay:before {
  content: "\\f184";
}

.fa-sun-o:before {
  content: "\\f185";
}

.fa-moon-o:before {
  content: "\\f186";
}

.fa-archive:before {
  content: "\\f187";
}

.fa-bug:before {
  content: "\\f188";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-arrow-circle-o-right:before {
  content: "\\f18e";
}

.fa-arrow-circle-o-left:before {
  content: "\\f190";
}

.fa-caret-square-o-left:before,
.fa-toggle-left:before {
  content: "\\f191";
}

.fa-dot-circle-o:before {
  content: "\\f192";
}

.fa-wheelchair:before {
  content: "\\f193";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-try:before,
.fa-turkish-lira:before {
  content: "\\f195";
}

.fa-plus-square-o:before {
  content: "\\f196";
}

.fa-space-shuttle:before {
  content: "\\f197";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-envelope-square:before {
  content: "\\f199";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-bank:before,
.fa-institution:before,
.fa-university:before {
  content: "\\f19c";
}

.fa-graduation-cap:before,
.fa-mortar-board:before {
  content: "\\f19d";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-language:before {
  content: "\\f1ab";
}

.fa-fax:before {
  content: "\\f1ac";
}

.fa-building:before {
  content: "\\f1ad";
}

.fa-child:before {
  content: "\\f1ae";
}

.fa-paw:before {
  content: "\\f1b0";
}

.fa-spoon:before {
  content: "\\f1b1";
}

.fa-cube:before {
  content: "\\f1b2";
}

.fa-cubes:before {
  content: "\\f1b3";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-recycle:before {
  content: "\\f1b8";
}

.fa-automobile:before,
.fa-car:before {
  content: "\\f1b9";
}

.fa-cab:before,
.fa-taxi:before {
  content: "\\f1ba";
}

.fa-tree:before {
  content: "\\f1bb";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-database:before {
  content: "\\f1c0";
}

.fa-file-pdf-o:before {
  content: "\\f1c1";
}

.fa-file-word-o:before {
  content: "\\f1c2";
}

.fa-file-excel-o:before {
  content: "\\f1c3";
}

.fa-file-powerpoint-o:before {
  content: "\\f1c4";
}

.fa-file-image-o:before,
.fa-file-photo-o:before,
.fa-file-picture-o:before {
  content: "\\f1c5";
}

.fa-file-archive-o:before,
.fa-file-zip-o:before {
  content: "\\f1c6";
}

.fa-file-audio-o:before,
.fa-file-sound-o:before {
  content: "\\f1c7";
}

.fa-file-movie-o:before,
.fa-file-video-o:before {
  content: "\\f1c8";
}

.fa-file-code-o:before {
  content: "\\f1c9";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-life-bouy:before,
.fa-life-buoy:before,
.fa-life-ring:before,
.fa-life-saver:before,
.fa-support:before {
  content: "\\f1cd";
}

.fa-circle-o-notch:before {
  content: "\\f1ce";
}

.fa-ra:before,
.fa-rebel:before,
.fa-resistance:before {
  content: "\\f1d0";
}

.fa-empire:before,
.fa-ge:before {
  content: "\\f1d1";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-hacker-news:before,
.fa-y-combinator-square:before,
.fa-yc-square:before {
  content: "\\f1d4";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-wechat:before,
.fa-weixin:before {
  content: "\\f1d7";
}

.fa-paper-plane:before,
.fa-send:before {
  content: "\\f1d8";
}

.fa-paper-plane-o:before,
.fa-send-o:before {
  content: "\\f1d9";
}

.fa-history:before {
  content: "\\f1da";
}

.fa-circle-thin:before {
  content: "\\f1db";
}

.fa-header:before {
  content: "\\f1dc";
}

.fa-paragraph:before {
  content: "\\f1dd";
}

.fa-sliders:before {
  content: "\\f1de";
}

.fa-share-alt:before {
  content: "\\f1e0";
}

.fa-share-alt-square:before {
  content: "\\f1e1";
}

.fa-bomb:before {
  content: "\\f1e2";
}

.fa-futbol-o:before,
.fa-soccer-ball-o:before {
  content: "\\f1e3";
}

.fa-tty:before {
  content: "\\f1e4";
}

.fa-binoculars:before {
  content: "\\f1e5";
}

.fa-plug:before {
  content: "\\f1e6";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-newspaper-o:before {
  content: "\\f1ea";
}

.fa-wifi:before {
  content: "\\f1eb";
}

.fa-calculator:before {
  content: "\\f1ec";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-bell-slash:before {
  content: "\\f1f6";
}

.fa-bell-slash-o:before {
  content: "\\f1f7";
}

.fa-trash:before {
  content: "\\f1f8";
}

.fa-copyright:before {
  content: "\\f1f9";
}

.fa-at:before {
  content: "\\f1fa";
}

.fa-eyedropper:before {
  content: "\\f1fb";
}

.fa-paint-brush:before {
  content: "\\f1fc";
}

.fa-birthday-cake:before {
  content: "\\f1fd";
}

.fa-area-chart:before {
  content: "\\f1fe";
}

.fa-pie-chart:before {
  content: "\\f200";
}

.fa-line-chart:before {
  content: "\\f201";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-toggle-off:before {
  content: "\\f204";
}

.fa-toggle-on:before {
  content: "\\f205";
}

.fa-bicycle:before {
  content: "\\f206";
}

.fa-bus:before {
  content: "\\f207";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-cc:before {
  content: "\\f20a";
}

.fa-ils:before,
.fa-shekel:before,
.fa-sheqel:before {
  content: "\\f20b";
}

.fa-meanpath:before {
  content: "\\f20c";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-cart-plus:before {
  content: "\\f217";
}

.fa-cart-arrow-down:before {
  content: "\\f218";
}

.fa-diamond:before {
  content: "\\f219";
}

.fa-ship:before {
  content: "\\f21a";
}

.fa-user-secret:before {
  content: "\\f21b";
}

.fa-motorcycle:before {
  content: "\\f21c";
}

.fa-street-view:before {
  content: "\\f21d";
}

.fa-heartbeat:before {
  content: "\\f21e";
}

.fa-venus:before {
  content: "\\f221";
}

.fa-mars:before {
  content: "\\f222";
}

.fa-mercury:before {
  content: "\\f223";
}

.fa-intersex:before,
.fa-transgender:before {
  content: "\\f224";
}

.fa-transgender-alt:before {
  content: "\\f225";
}

.fa-venus-double:before {
  content: "\\f226";
}

.fa-mars-double:before {
  content: "\\f227";
}

.fa-venus-mars:before {
  content: "\\f228";
}

.fa-mars-stroke:before {
  content: "\\f229";
}

.fa-mars-stroke-v:before {
  content: "\\f22a";
}

.fa-mars-stroke-h:before {
  content: "\\f22b";
}

.fa-neuter:before {
  content: "\\f22c";
}

.fa-genderless:before {
  content: "\\f22d";
}

.fa-facebook-official:before {
  content: "\\f230";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-server:before {
  content: "\\f233";
}

.fa-user-plus:before {
  content: "\\f234";
}

.fa-user-times:before {
  content: "\\f235";
}

.fa-bed:before,
.fa-hotel:before {
  content: "\\f236";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-train:before {
  content: "\\f238";
}

.fa-subway:before {
  content: "\\f239";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-y-combinator:before,
.fa-yc:before {
  content: "\\f23b";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-battery-4:before,
.fa-battery-full:before,
.fa-battery:before {
  content: "\\f240";
}

.fa-battery-3:before,
.fa-battery-three-quarters:before {
  content: "\\f241";
}

.fa-battery-2:before,
.fa-battery-half:before {
  content: "\\f242";
}

.fa-battery-1:before,
.fa-battery-quarter:before {
  content: "\\f243";
}

.fa-battery-0:before,
.fa-battery-empty:before {
  content: "\\f244";
}

.fa-mouse-pointer:before {
  content: "\\f245";
}

.fa-i-cursor:before {
  content: "\\f246";
}

.fa-object-group:before {
  content: "\\f247";
}

.fa-object-ungroup:before {
  content: "\\f248";
}

.fa-sticky-note:before {
  content: "\\f249";
}

.fa-sticky-note-o:before {
  content: "\\f24a";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-clone:before {
  content: "\\f24d";
}

.fa-balance-scale:before {
  content: "\\f24e";
}

.fa-hourglass-o:before {
  content: "\\f250";
}

.fa-hourglass-1:before,
.fa-hourglass-start:before {
  content: "\\f251";
}

.fa-hourglass-2:before,
.fa-hourglass-half:before {
  content: "\\f252";
}

.fa-hourglass-3:before,
.fa-hourglass-end:before {
  content: "\\f253";
}

.fa-hourglass:before {
  content: "\\f254";
}

.fa-hand-grab-o:before,
.fa-hand-rock-o:before {
  content: "\\f255";
}

.fa-hand-paper-o:before,
.fa-hand-stop-o:before {
  content: "\\f256";
}

.fa-hand-scissors-o:before {
  content: "\\f257";
}

.fa-hand-lizard-o:before {
  content: "\\f258";
}

.fa-hand-spock-o:before {
  content: "\\f259";
}

.fa-hand-pointer-o:before {
  content: "\\f25a";
}

.fa-hand-peace-o:before {
  content: "\\f25b";
}

.fa-trademark:before {
  content: "\\f25c";
}

.fa-registered:before {
  content: "\\f25d";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-tripadvisor:before {
  content: "\\f262";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-television:before,
.fa-tv:before {
  content: "\\f26c";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-calendar-plus-o:before {
  content: "\\f271";
}

.fa-calendar-minus-o:before {
  content: "\\f272";
}

.fa-calendar-times-o:before {
  content: "\\f273";
}

.fa-calendar-check-o:before {
  content: "\\f274";
}

.fa-industry:before {
  content: "\\f275";
}

.fa-map-pin:before {
  content: "\\f276";
}

.fa-map-signs:before {
  content: "\\f277";
}

.fa-map-o:before {
  content: "\\f278";
}

.fa-map:before {
  content: "\\f279";
}

.fa-commenting:before {
  content: "\\f27a";
}

.fa-commenting-o:before {
  content: "\\f27b";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-vimeo:before {
  content: "\\f27d";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-credit-card-alt:before {
  content: "\\f283";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-pause-circle:before {
  content: "\\f28b";
}

.fa-pause-circle-o:before {
  content: "\\f28c";
}

.fa-stop-circle:before {
  content: "\\f28d";
}

.fa-stop-circle-o:before {
  content: "\\f28e";
}

.fa-shopping-bag:before {
  content: "\\f290";
}

.fa-shopping-basket:before {
  content: "\\f291";
}

.fa-hashtag:before {
  content: "\\f292";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-percent:before {
  content: "\\f295";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-universal-access:before {
  content: "\\f29a";
}

.fa-wheelchair-alt:before {
  content: "\\f29b";
}

.fa-question-circle-o:before {
  content: "\\f29c";
}

.fa-blind:before {
  content: "\\f29d";
}

.fa-audio-description:before {
  content: "\\f29e";
}

.fa-volume-control-phone:before {
  content: "\\f2a0";
}

.fa-braille:before {
  content: "\\f2a1";
}

.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}

.fa-american-sign-language-interpreting:before,
.fa-asl-interpreting:before {
  content: "\\f2a3";
}

.fa-deaf:before,
.fa-deafness:before,
.fa-hard-of-hearing:before {
  content: "\\f2a4";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-sign-language:before,
.fa-signing:before {
  content: "\\f2a7";
}

.fa-low-vision:before {
  content: "\\f2a8";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ac";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-google-plus-circle:before,
.fa-google-plus-official:before {
  content: "\\f2b3";
}

.fa-fa:before,
.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-handshake-o:before {
  content: "\\f2b5";
}

.fa-envelope-open:before {
  content: "\\f2b6";
}

.fa-envelope-open-o:before {
  content: "\\f2b7";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-address-book:before {
  content: "\\f2b9";
}

.fa-address-book-o:before {
  content: "\\f2ba";
}

.fa-address-card:before,
.fa-vcard:before {
  content: "\\f2bb";
}

.fa-address-card-o:before,
.fa-vcard-o:before {
  content: "\\f2bc";
}

.fa-user-circle:before {
  content: "\\f2bd";
}

.fa-user-circle-o:before {
  content: "\\f2be";
}

.fa-user-o:before {
  content: "\\f2c0";
}

.fa-id-badge:before {
  content: "\\f2c1";
}

.fa-drivers-license:before,
.fa-id-card:before {
  content: "\\f2c2";
}

.fa-drivers-license-o:before,
.fa-id-card-o:before {
  content: "\\f2c3";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-thermometer-4:before,
.fa-thermometer-full:before,
.fa-thermometer:before {
  content: "\\f2c7";
}

.fa-thermometer-3:before,
.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.fa-thermometer-2:before,
.fa-thermometer-half:before {
  content: "\\f2c9";
}

.fa-thermometer-1:before,
.fa-thermometer-quarter:before {
  content: "\\f2ca";
}

.fa-thermometer-0:before,
.fa-thermometer-empty:before {
  content: "\\f2cb";
}

.fa-shower:before {
  content: "\\f2cc";
}

.fa-bath:before,
.fa-bathtub:before,
.fa-s15:before {
  content: "\\f2cd";
}

.fa-podcast:before {
  content: "\\f2ce";
}

.fa-window-maximize:before {
  content: "\\f2d0";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-window-restore:before {
  content: "\\f2d2";
}

.fa-times-rectangle:before,
.fa-window-close:before {
  content: "\\f2d3";
}

.fa-times-rectangle-o:before,
.fa-window-close-o:before {
  content: "\\f2d4";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-eercast:before {
  content: "\\f2da";
}

.fa-microchip:before {
  content: "\\f2db";
}

.fa-snowflake-o:before {
  content: "\\f2dc";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oEAA+D;EAC/D,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,iEAAiE;AACjE,8FAA8F;;AAE9F,iEAAiE;AACjE,8FAA8F;AAC9F;EAGE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT;iDAC+C;AACjD;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE;aACW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;EAKE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;;EAGE,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE;;wEAEsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;;;EAGE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAQA;;EAEE,UAAU;EACV,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;;;;EAKE,UAAU;EACV,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;;EAIE;2CACyC;AAC3C;;AAEA;;;;;;;;EAQE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,sBAAsB;EACtB,2DAA2D;EAC3D;;;KAGG;EACH,2BAA2B;EAC3B,4BAA4B;EAC5B,wCAAwC;EACxC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH,sLAAsL;EACtL;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH;;;KAGG;EACH,4QAA4Q;AAC9Q;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;EACtD,+DAA+D;AACjE;;AAEA;EACE,uBAAuB;EACvB,oDAAoD;EACpD,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;EACxB,kEAAkE;EAClE,2DAA2D;AAC7D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,4EAA4E;EAC5E;sDACoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE;IACE,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,cAAc;;EAEhB;AACF;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;;;;;;;;;;;;;;;;GAgBG;;AAEH;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,MAAM;EACN,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,oBAAoB;EACpB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,uBAAuB;EACvB,uDAAuD;EACvD,gEAAgE;AAClE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE;;IAEE,2BAA2B;IAC3B,qDAAqD;EACvD;;EAEA;IACE,eAAe;IACf,qDAAqD;EACvD;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,yDAAyD;EACzD,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG;+BAC6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,4DAA4D;AAC9D;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;;EAGE;AACF;EACE,wBAAwB;EACxB,4CAAkD;EAClD;;;;iBAIe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sEAAsE;EACtE,wBAAwB;AAC1B;;AAEA;EACE,sEAAsE;EACtE,yBAAyB;AAC3B;;AAEA;EACE,sEAAsE;EACtE,yBAAyB;AAC3B;;AAEA;EACE,gFAAgF;EAChF,qBAAqB;AACvB;;AAEA;EACE,gFAAgF;EAChF,qBAAqB;AACvB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,UAAU;AACZ","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.whatsapp-icon-div {\n  /* border: 1px solid black; */\n  top: 45%;\n  left: .5cm;\n  position: fixed;\n  /* inset: 0; */\n  z-index: 50;\n  /* width: fit-content; */\n  /* height: fit-content; */\n  padding: .2cm;\n  border-radius: 50%;\n  background-color: #25d366;\n  cursor: pointer;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.header {\n  width: 90%;\n  height: 17cm;\n  background: url('../public/img/mainImage.svg') bottom no-repeat;\n  background-size: 250pt;\n  position: relative;\n  padding-top: 20px;\n  background-color: #fff;\n  background-attachment: scroll;\n  background-position-y: 190px;\n  /* border: 1px solid black; */\n}\n\n/*! tailwindcss v2.2.19 | MIT License | https://tailwindcss.com */\n/*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */\n\n/*! tailwindcss v2.2.19 | MIT License | https://tailwindcss.com */\n/*! modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */\nhtml {\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial,\n    sans-serif, Apple Color Emoji, Segoe UI Emoji;\n}\n\nhr {\n  height: 0;\n  color: inherit;\n}\n\nabbr[title] {\n  -webkit-text-decoration: underline dotted;\n  text-decoration: underline dotted;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: ui-monospace, SFMono-Regular, Consolas, Liberation Mono, Menlo,\n    monospace;\n  font-size: 1em;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\ntable {\n  text-indent: 0;\n  border-color: inherit;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"],\nbutton {\n  -webkit-appearance: button;\n}\n\n::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\nlegend {\n  padding: 0;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n}\n\nsummary {\n  display: list-item;\n}\n\nblockquote,\ndd,\ndl,\nfigure,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\np,\npre {\n  margin: 0;\n}\n\nbutton {\n  background-color: transparent;\n  background-image: none;\n}\n\nfieldset,\nol,\nul {\n  margin: 0;\n  padding: 0;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nhtml {\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,\n    Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif,\n    Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n  line-height: 1.5;\n}\n\nbody {\n  font-family: inherit;\n  line-height: inherit;\n}\n\n*,\n:after,\n:before {\n  box-sizing: border-box;\n  border: 0 solid;\n}\n\nhr {\n  border-top-width: 1px;\n}\n\nimg {\n  border-style: solid;\n}\n\ntextarea {\n  resize: vertical;\n}\n\ninput::-moz-placeholder,\ntextarea::-moz-placeholder {\n  opacity: 1;\n  color: #9ca3af;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1;\n  color: #9ca3af;\n}\n\n[role=\"button\"],\nbutton {\n  cursor: pointer;\n}\n\n:-moz-focusring {\n  outline: auto;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  padding: 0;\n  line-height: inherit;\n  color: inherit;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,\n    Liberation Mono, Courier New, monospace;\n}\n\naudio,\ncanvas,\nembed,\niframe,\nimg,\nobject,\nsvg,\nvideo {\n  display: block;\n  vertical-align: middle;\n}\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n[hidden] {\n  display: none;\n}\n\n*,\n:after,\n:before {\n  --tw-border-opacity: 1;\n  border-color: rgba(229, 231, 235, var(--tw-border-opacity));\n  --tw-ring-inset: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgba(59, 130, 246, 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-blur: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-brightness: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-contrast: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-grayscale: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-hue-rotate: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-invert: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-saturate: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-sepia: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-drop-shadow: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n  --tw-backdrop-blur: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-backdrop-brightness: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-backdrop-contrast: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-backdrop-grayscale: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-backdrop-hue-rotate: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-backdrop-invert: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-backdrop-opacity: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-backdrop-saturate: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-backdrop-sepia: var(--tw-empty,\n      /*!*/\n      /*!*/\n    );\n  --tw-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);\n}\n\n.container {\n  width: 100%;\n}\n\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .container {\n    max-width: 1024px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .container {\n    max-width: 1280px;\n  }\n}\n\n@media (min-width: 1536px) {\n  .container {\n    max-width: 1536px;\n  }\n}\n\n.sr-only {\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.visible {\n  visibility: visible;\n}\n\n.invisible {\n  visibility: hidden;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.sticky {\n  position: sticky;\n}\n\n.top-0 {\n  top: 0;\n}\n\n.bottom-96 {\n  bottom: 24rem;\n}\n\n.z-50 {\n  z-index: 50;\n}\n\n.z-10 {\n  z-index: 10;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.-mx-5 {\n  margin-left: -1.25rem;\n  margin-right: -1.25rem;\n}\n\n.-my-2 {\n  margin-top: -0.5rem;\n  margin-bottom: -0.5rem;\n}\n\n.my-2 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.my-4 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.mt-12 {\n  margin-top: 3rem;\n}\n\n.mb-10 {\n  margin-bottom: 2.5rem;\n}\n\n.mr-5 {\n  margin-right: 1.25rem;\n}\n\n.mt-8 {\n  margin-top: 2rem;\n}\n\n.mt-10 {\n  margin-top: 2.5rem;\n}\n\n.-mr-2 {\n  margin-right: -0.5rem;\n}\n\n.mt-4 {\n  margin-top: 1rem;\n}\n\n.mr-2 {\n  margin-right: 0.5rem;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mt-6 {\n  margin-top: 1.5rem;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n\n.mt-3 {\n  margin-top: 0.75rem;\n}\n\n.block {\n  display: block;\n}\n\n.flex {\n  display: flex;\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n.table {\n  display: table;\n}\n\n.grid {\n  display: grid;\n}\n\n.hidden {\n  display: none;\n}\n\n.h-screen {\n  height: 100vh;\n}\n\n.h-7 {\n  height: 1.75rem;\n}\n\n.h-12 {\n  height: 3rem;\n}\n\n.h-6 {\n  height: 1.5rem;\n}\n\n.h-16 {\n  height: 4rem;\n}\n\n.h-32 {\n  height: 8rem;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-72 {\n  height: 18rem;\n}\n\n.min-h-screen {\n  min-height: 100vh;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.w-5\\/6 {\n  width: 83.333333%;\n}\n\n.w-32 {\n  width: 8rem;\n}\n\n.w-20 {\n  width: 5rem;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-6 {\n  width: 1.5rem;\n}\n\n.w-screen {\n  width: 100vw;\n}\n\n.w-72 {\n  width: 18rem;\n}\n\n.w-48 {\n  width: 12rem;\n}\n\n.w-11 {\n  width: 2.75rem;\n}\n\n.max-w-7xl {\n  max-width: 80rem;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n\n.flex-grow {\n  flex-grow: 1;\n}\n\n.border-collapse {\n  border-collapse: collapse;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.items-stretch {\n  align-items: stretch;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.space-x-6> :not([hidden])~ :not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(1.5rem * var(--tw-space-x-reverse));\n  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));\n}\n\n.space-x-4> :not([hidden])~ :not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(1rem * var(--tw-space-x-reverse));\n  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));\n}\n\n.space-y-1> :not([hidden])~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));\n}\n\n.divide-y> :not([hidden])~ :not([hidden]) {\n  --tw-divide-y-reverse: 0;\n  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));\n  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n\n.rounded-md {\n  border-radius: 0.375rem;\n}\n\n.rounded-full {\n  border-radius: 9999px;\n}\n\n.rounded-b-md {\n  border-bottom-right-radius: 0.375rem;\n  border-bottom-left-radius: 0.375rem;\n}\n\n.rounded-r-lg {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n\n.border {\n  border-width: 1px;\n}\n\n.border-2 {\n  border-width: 2px;\n}\n\n.border-l-4 {\n  border-left-width: 4px;\n}\n\n.border-orange {\n  --tw-border-opacity: 1;\n  border-color: rgba(246, 68, 1, var(--tw-border-opacity));\n}\n\n.border-white {\n  --tw-border-opacity: 1;\n  border-color: rgba(255, 255, 255, var(--tw-border-opacity));\n}\n\n.border-l-orange {\n  --tw-border-opacity: 1;\n  border-left-color: rgba(246, 68, 1, var(--tw-border-opacity));\n}\n\n.bg-orange {\n  --tw-bg-opacity: 1;\n  background-color: rgba(246, 68, 1, var(--tw-bg-opacity));\n}\n\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n}\n\n.bg-gray-900 {\n  --tw-bg-opacity: 1;\n  background-color: rgba(17, 24, 39, var(--tw-bg-opacity));\n}\n\n.bg-pink {\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 224, 229, var(--tw-bg-opacity));\n}\n\n.bg-green-600 {\n  --tw-bg-opacity: 1;\n  background-color: rgba(5, 150, 105, var(--tw-bg-opacity));\n}\n\n.bg-gray-100 {\n  --tw-bg-opacity: 1;\n  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));\n}\n\n.bg-opacity-80 {\n  --tw-bg-opacity: 0.8;\n}\n\n.bg-opacity-70 {\n  --tw-bg-opacity: 0.7;\n}\n\n.p-2 {\n  padding: 0.5rem;\n}\n\n.p-4 {\n  padding: 1rem;\n}\n\n.p-3 {\n  padding: 0.75rem;\n}\n\n.px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.px-5 {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.pr-40 {\n  padding-right: 10rem;\n}\n\n.pt-1 {\n  padding-top: 0.25rem;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem;\n}\n\n.pt-2 {\n  padding-top: 0.5rem;\n}\n\n.pb-3 {\n  padding-bottom: 0.75rem;\n}\n\n.pt-4 {\n  padding-top: 1rem;\n}\n\n.pr-4 {\n  padding-right: 1rem;\n}\n\n.pr-8 {\n  padding-right: 2rem;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.align-middle {\n  vertical-align: middle;\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.text-xxs {\n  font-size: 0.6rem;\n}\n\n.text-base {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n\n.text-4xl {\n  font-size: 2.25rem;\n  line-height: 2.5rem;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.text-orange {\n  --tw-text-opacity: 1;\n  color: rgba(246, 68, 1, var(--tw-text-opacity));\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--tw-text-opacity));\n}\n\n.text-gray-300 {\n  --tw-text-opacity: 1;\n  color: rgba(209, 213, 219, var(--tw-text-opacity));\n}\n\n.text-gray-400 {\n  --tw-text-opacity: 1;\n  color: rgba(156, 163, 175, var(--tw-text-opacity));\n}\n\n.text-gray-800 {\n  --tw-text-opacity: 1;\n  color: rgba(31, 41, 55, var(--tw-text-opacity));\n}\n\n.shadow {\n  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),\n    var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n\n.filter {\n  filter: var(--tw-filter);\n}\n\n.backdrop-blur {\n  --tw-backdrop-blur: blur(8px);\n}\n\n.backdrop-blur,\n.backdrop-filter {\n  -webkit-backdrop-filter: var(--tw-backdrop-filter);\n  backdrop-filter: var(--tw-backdrop-filter);\n}\n\n.play-zoom {\n  animation: playzoom 1s infinite;\n}\n\n@keyframes playzoom {\n  0% {\n    background-position: 50%;\n    transform: scale(1);\n  }\n\n  50% {\n    background-position: 50%;\n    transform: scale(1.2);\n  }\n\n  to {\n    background-position: 50%;\n    transform: scale(1);\n  }\n}\n\n.btn.btn-circle {\n  background-color: #f64401;\n  border-radius: 50%;\n  width: 60px;\n  color: #fff;\n  height: 60px;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px #f64401b3;\n  outline: none;\n  padding-top: 5px;\n  border: 2px solid #fff;\n}\n\n.btn.btn-circle i {\n  font-size: 32px;\n}\n\n\n@media only screen and (max-width : 768px) {\n  .header {\n    /* width: 50%; */\n    background-size: 200pt;\n    background-position-y: 130px;\n    height: 15.5cm;\n\n  }\n}\n\n/* \n@media (max-width: 768px) {\n  .header {\n    width: 90%;\n    background-size: 200pt;\n    height: 35vh;\n    background-position-y: 120px;\n  }\n}\n\n@media (max-width : 500px) {\n  .header {\n    width: 90%;\n    background-size: 200pt;\n    height: 100vh;\n    background-position-y: 170px;\n  }\n} */\n\n/* @media (min-height : 500px) {\n  .header {\n    width: 90%;\n    background-size: 200pt;\n    height: 80vh;\n    background-position-y: 170px;\n  }\n}\n\n@media (min-height : 900px) {\n  .header {\n    width: 90%;\n    background-size: 200pt;\n    height: 60vh;\n    background-position-y: 170px;\n  }\n} */\n\n.divTable {\n  align-items: center;\n  align-items: stretch;\n  text-align: center;\n  margin-top: 2.5cm;\n}\n\n.thChartDate {\n  width: 120px;\n  font-size: small;\n  border: 1px solid #017ba0b4;\n  padding: 20px;\n}\n\n.thChartDate,\n.thChartHeader {\n  height: 50px;\n  text-align: center;\n}\n\n.thChartHeader {\n  width: 65px;\n  border: 1px solid #c3d0f0b4;\n  top: 0;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  --tw-text-opacity: 1;\n  color: rgba(17, 24, 39, var(--tw-text-opacity));\n}\n\n@media (min-width: 768px) {\n  .thChartHeader {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n.headerDate {\n  font-size: 0.6rem;\n}\n\n@media (min-width: 768px) {\n  .headerDate {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n.fontResult {\n  font-size: 15px !important;\n  font-weight: 700 !important;\n}\n\n.tdChartDate {\n  width: 95px;\n  padding: 0 4px;\n}\n\n.tdChartDate,\n.thChartResult {\n  height: 50px;\n  border: 1px solid #c3d0f0b4;\n  text-align: center;\n}\n\n.thChartResult {\n  width: 75px;\n}\n\n.fontResultCustom {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.tdChartGreen {\n  --tw-bg-opacity: 1;\n  background-color: rgba(239, 68, 68, var(--tw-bg-opacity));\n  --tw-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--tw-text-opacity));\n  text-align: center;\n}\n\n.redList {\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n  color: red;\n}\n\n.tdChartRed {\n  border: 1px solid #649afdaa;\n  text-align: center;\n}\n\n.gameNameChart {\n  margin-top: 1.25rem;\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n  --tw-text-opacity: 1;\n  color: rgba(246, 68, 1, var(--tw-text-opacity));\n}\n\n.gameNameDesc {\n  margin: 0.25rem 0.25rem 1rem;\n  justify-content: center;\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n@media (min-width: 768px) {\n  .gameNameDesc {\n    font-size: 0.9em;\n  }\n}\n\n.viewChartFont {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n@media (min-width: 768px) {\n  .viewChartFont {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n.spanPannaUp {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.spanPannaCenter {\n  text-align: inherit;\n  vertical-align: middle;\n}\n\ndiv.divPanna {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.tdDate {\n  font-weight: 500;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: flex-start;\n}\n\n.dateDivLeft {\n  font-size: 0.9em;\n  --tw-text-opacity: 1;\n  color: rgba(17, 24, 39, var(--tw-text-opacity));\n}\n\n@media (min-width: 768px) {\n  .dateDivLeft {\n    font-size: 0.6rem;\n  }\n}\n\n.dateDivLeft {\n  writing-mode: vertical-rl;\n  text-orientation: upright;\n}\n\n.dateDivRight {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  font-size: 0.6rem;\n  --tw-text-opacity: 1;\n  color: rgba(17, 24, 39, var(--tw-text-opacity));\n}\n\n@media (min-width: 768px) {\n  .dateDivRight {\n    font-size: 0.75rem;\n    line-height: 1rem;\n  }\n}\n\n.divBottomButtons> :not([hidden])~ :not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(0.25rem * var(--tw-space-x-reverse));\n  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));\n}\n\n.divBottomButtons {\n  padding: 1.25rem;\n}\n\n.hangingButtons {\n  position: fixed;\n  left: 0.25rem;\n}\n\n.bounce,\n.hangingButtons {\n  margin-top: 0.75rem;\n}\n\n@keyframes bounce {\n\n  0%,\n  to {\n    transform: translateY(-25%);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n\n  50% {\n    transform: none;\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n}\n\n.bounce {\n  animation: bounce 1s infinite;\n}\n\n.chartHeading {\n  margin-top: 1.25rem;\n  margin-bottom: 0.25rem;\n  width: 100%;\n  --tw-bg-opacity: 1;\n  background-color: rgba(239, 68, 68, var(--tw-bg-opacity));\n  padding: 0.75rem;\n  text-align: center;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 700;\n  --tw-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--tw-text-opacity));\n}\n\n@media (min-width: 768px) {\n  .chartHeading {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n  }\n}\n\n.gameNameRow {\n  line-height: 47px !important;\n  margin: 0.25rem;\n  height: 3rem;\n  border-width: 1px;\n  text-align: center;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 700;\n  letter-spacing: 0.025em;\n  --tw-text-opacity: 1;\n  color: rgba(246, 68, 1, var(--tw-text-opacity));\n}\n\n@media (min-width: 768px) {\n  .gameNameRow {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n.clsResultsTable {\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 0.6rem;\n}\n\n@media (min-width: 768px) {\n  .clsResultsTable {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n.divResultsTable {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.parentDiv {\n  font-family: Lora, serif;\n  margin: 1.5rem 0.25rem 2rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  --tw-text-opacity: 1;\n  color: rgba(17, 24, 39, var(--tw-text-opacity));\n}\n\n@media (min-width: 768px) {\n  .parentDiv {\n    margin-right: 8rem;\n    margin-left: 8rem;\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n.titleDiv {\n  margin-top: 1rem;\n}\n\n.center {\n  padding-top: 1rem;\n  text-align: center;\n  font-size: 1.5rem;\n  line-height: 2rem;\n  font-weight: 600;\n}\n\n.feature_divider {\n  margin: 0.75rem auto 2rem;\n  height: 1px;\n  width: 8rem;\n  border-width: 1px;\n  border-style: solid;\n  --tw-border-opacity: 1;\n  border-color: rgba(0, 0, 0, var(--tw-border-opacity));\n}\n\n.divParagraph {\n  margin: 2rem;\n}\n\n.paragraph {\n  margin-top: 1rem;\n  margin-bottom: 2rem;\n  text-align: justify;\n  line-height: 1.5rem;\n}\n\nul li {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  margin-left: 1.5rem;\n  text-align: justify;\n}\n\n.h2htp {\n  text-align: center;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  --tw-text-opacity: 1;\n  color: rgba(246, 68, 1, var(--tw-text-opacity));\n}\n\n@media (min-width: 768px) {\n  .h2htp {\n    font-size: 1.5rem;\n    line-height: 2rem;\n  }\n}\n\n.auheading {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  --tw-text-opacity: 1;\n  color: rgba(55, 65, 81, var(--tw-text-opacity));\n}\n\n@media (min-width: 768px) {\n  .auheading {\n    font-size: 1.5rem;\n    line-height: 2rem;\n  }\n}\n\n.autext {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n@media (min-width: 768px) {\n  .autext {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n.hover\\:bg-gray-700:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgba(55, 65, 81, var(--tw-bg-opacity));\n}\n\n.hover\\:bg-orange:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgba(246, 68, 1, var(--tw-bg-opacity));\n}\n\n.hover\\:text-gray-900:hover {\n  --tw-text-opacity: 1;\n  color: rgba(17, 24, 39, var(--tw-text-opacity));\n}\n\n.hover\\:text-gray-500:hover {\n  --tw-text-opacity: 1;\n  color: rgba(107, 114, 128, var(--tw-text-opacity));\n}\n\n.hover\\:text-white:hover {\n  --tw-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--tw-text-opacity));\n}\n\n.focus\\:outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.focus\\:ring-2:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),\n    var(--tw-shadow, 0 0 #0000);\n}\n\n.focus\\:ring-inset:focus {\n  --tw-ring-inset: inset;\n}\n\n.focus\\:ring-white:focus {\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgba(255, 255, 255, var(--tw-ring-opacity));\n}\n\n@media (min-width: 640px) {\n  .sm\\:ml-6 {\n    margin-left: 1.5rem;\n  }\n\n  .sm\\:block {\n    display: block;\n  }\n\n  .sm\\:hidden {\n    display: none;\n  }\n\n  .sm\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .sm\\:text-4xl {\n    font-size: 2.25rem;\n    line-height: 2.5rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:grid {\n    display: grid;\n  }\n\n  .md\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .md\\:gap-4 {\n    gap: 1rem;\n  }\n\n  .md\\:gap-2 {\n    gap: 0.5rem;\n  }\n\n  .md\\:text-base {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n\n  .md\\:text-lg {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n  }\n\n  .md\\:text-6xl {\n    font-size: 3.75rem;\n    line-height: 1;\n  }\n\n  .md\\:text-3xl {\n    font-size: 1.875rem;\n    line-height: 2.25rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n@font-face {\n  font-family: FontAwesome;\n  src: url(./fonts/fontawesome-webfont.2b13baa7.eot);\n  src: url(./fonts/fontawesome-webfont.2b13baa7.eot#iefix&v=4.7.0) format(\"embedded-opentype\"),\n    url(./fonts/fontawesome-webfont.e9955780.woff2) format(\"woff2\"),\n    url(./fonts/fontawesome-webfont.cf011583.woff) format(\"woff\"),\n    url(./fonts/fontawesome-webfont.8a7cb27d.ttf) format(\"truetype\"),\n    format(\"svg\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n.fa {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.fa-lg {\n  font-size: 1.33333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-fw {\n  width: 1.28571429em;\n  text-align: center;\n}\n\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n\n.fa-ul>li {\n  position: relative;\n}\n\n.fa-li {\n  position: absolute;\n  left: -2.14285714em;\n  width: 2.14285714em;\n  top: 0.14285714em;\n  text-align: center;\n}\n\n.fa-li.fa-lg {\n  left: -1.85714286em;\n}\n\n.fa-border {\n  padding: 0.2em 0.25em 0.15em;\n  border: 0.08em solid #eee;\n  border-radius: 0.1em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left {\n  margin-right: 0.3em;\n}\n\n.fa.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pull-left {\n  float: left;\n}\n\n.fa.pull-left {\n  margin-right: 0.3em;\n}\n\n.fa.pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  animation: fa-spin 2s linear infinite;\n}\n\n.fa-pulse {\n  animation: fa-spin 1s steps(8) infinite;\n}\n\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  transform: scaleX(-1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  transform: scaleY(-1);\n}\n\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-rotate-90 {\n  filter: none;\n}\n\n.fa-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.fa-stack-1x {\n  line-height: inherit;\n}\n\n.fa-stack-2x {\n  font-size: 2em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.fa-glass:before {\n  content: \"\\f000\";\n}\n\n.fa-music:before {\n  content: \"\\f001\";\n}\n\n.fa-search:before {\n  content: \"\\f002\";\n}\n\n.fa-envelope-o:before {\n  content: \"\\f003\";\n}\n\n.fa-heart:before {\n  content: \"\\f004\";\n}\n\n.fa-star:before {\n  content: \"\\f005\";\n}\n\n.fa-star-o:before {\n  content: \"\\f006\";\n}\n\n.fa-user:before {\n  content: \"\\f007\";\n}\n\n.fa-film:before {\n  content: \"\\f008\";\n}\n\n.fa-th-large:before {\n  content: \"\\f009\";\n}\n\n.fa-th:before {\n  content: \"\\f00a\";\n}\n\n.fa-th-list:before {\n  content: \"\\f00b\";\n}\n\n.fa-check:before {\n  content: \"\\f00c\";\n}\n\n.fa-close:before,\n.fa-remove:before,\n.fa-times:before {\n  content: \"\\f00d\";\n}\n\n.fa-search-plus:before {\n  content: \"\\f00e\";\n}\n\n.fa-search-minus:before {\n  content: \"\\f010\";\n}\n\n.fa-power-off:before {\n  content: \"\\f011\";\n}\n\n.fa-signal:before {\n  content: \"\\f012\";\n}\n\n.fa-cog:before,\n.fa-gear:before {\n  content: \"\\f013\";\n}\n\n.fa-trash-o:before {\n  content: \"\\f014\";\n}\n\n.fa-home:before {\n  content: \"\\f015\";\n}\n\n.fa-file-o:before {\n  content: \"\\f016\";\n}\n\n.fa-clock-o:before {\n  content: \"\\f017\";\n}\n\n.fa-road:before {\n  content: \"\\f018\";\n}\n\n.fa-download:before {\n  content: \"\\f019\";\n}\n\n.fa-arrow-circle-o-down:before {\n  content: \"\\f01a\";\n}\n\n.fa-arrow-circle-o-up:before {\n  content: \"\\f01b\";\n}\n\n.fa-inbox:before {\n  content: \"\\f01c\";\n}\n\n.fa-play-circle-o:before {\n  content: \"\\f01d\";\n}\n\n.fa-repeat:before,\n.fa-rotate-right:before {\n  content: \"\\f01e\";\n}\n\n.fa-refresh:before {\n  content: \"\\f021\";\n}\n\n.fa-list-alt:before {\n  content: \"\\f022\";\n}\n\n.fa-lock:before {\n  content: \"\\f023\";\n}\n\n.fa-flag:before {\n  content: \"\\f024\";\n}\n\n.fa-headphones:before {\n  content: \"\\f025\";\n}\n\n.fa-volume-off:before {\n  content: \"\\f026\";\n}\n\n.fa-volume-down:before {\n  content: \"\\f027\";\n}\n\n.fa-volume-up:before {\n  content: \"\\f028\";\n}\n\n.fa-qrcode:before {\n  content: \"\\f029\";\n}\n\n.fa-barcode:before {\n  content: \"\\f02a\";\n}\n\n.fa-tag:before {\n  content: \"\\f02b\";\n}\n\n.fa-tags:before {\n  content: \"\\f02c\";\n}\n\n.fa-book:before {\n  content: \"\\f02d\";\n}\n\n.fa-bookmark:before {\n  content: \"\\f02e\";\n}\n\n.fa-print:before {\n  content: \"\\f02f\";\n}\n\n.fa-camera:before {\n  content: \"\\f030\";\n}\n\n.fa-font:before {\n  content: \"\\f031\";\n}\n\n.fa-bold:before {\n  content: \"\\f032\";\n}\n\n.fa-italic:before {\n  content: \"\\f033\";\n}\n\n.fa-text-height:before {\n  content: \"\\f034\";\n}\n\n.fa-text-width:before {\n  content: \"\\f035\";\n}\n\n.fa-align-left:before {\n  content: \"\\f036\";\n}\n\n.fa-align-center:before {\n  content: \"\\f037\";\n}\n\n.fa-align-right:before {\n  content: \"\\f038\";\n}\n\n.fa-align-justify:before {\n  content: \"\\f039\";\n}\n\n.fa-list:before {\n  content: \"\\f03a\";\n}\n\n.fa-dedent:before,\n.fa-outdent:before {\n  content: \"\\f03b\";\n}\n\n.fa-indent:before {\n  content: \"\\f03c\";\n}\n\n.fa-video-camera:before {\n  content: \"\\f03d\";\n}\n\n.fa-image:before,\n.fa-photo:before,\n.fa-picture-o:before {\n  content: \"\\f03e\";\n}\n\n.fa-pencil:before {\n  content: \"\\f040\";\n}\n\n.fa-map-marker:before {\n  content: \"\\f041\";\n}\n\n.fa-adjust:before {\n  content: \"\\f042\";\n}\n\n.fa-tint:before {\n  content: \"\\f043\";\n}\n\n.fa-edit:before,\n.fa-pencil-square-o:before {\n  content: \"\\f044\";\n}\n\n.fa-share-square-o:before {\n  content: \"\\f045\";\n}\n\n.fa-check-square-o:before {\n  content: \"\\f046\";\n}\n\n.fa-arrows:before {\n  content: \"\\f047\";\n}\n\n.fa-step-backward:before {\n  content: \"\\f048\";\n}\n\n.fa-fast-backward:before {\n  content: \"\\f049\";\n}\n\n.fa-backward:before {\n  content: \"\\f04a\";\n}\n\n.fa-play:before {\n  content: \"\\f04b\";\n}\n\n.fa-pause:before {\n  content: \"\\f04c\";\n}\n\n.fa-stop:before {\n  content: \"\\f04d\";\n}\n\n.fa-forward:before {\n  content: \"\\f04e\";\n}\n\n.fa-fast-forward:before {\n  content: \"\\f050\";\n}\n\n.fa-step-forward:before {\n  content: \"\\f051\";\n}\n\n.fa-eject:before {\n  content: \"\\f052\";\n}\n\n.fa-chevron-left:before {\n  content: \"\\f053\";\n}\n\n.fa-chevron-right:before {\n  content: \"\\f054\";\n}\n\n.fa-plus-circle:before {\n  content: \"\\f055\";\n}\n\n.fa-minus-circle:before {\n  content: \"\\f056\";\n}\n\n.fa-times-circle:before {\n  content: \"\\f057\";\n}\n\n.fa-check-circle:before {\n  content: \"\\f058\";\n}\n\n.fa-question-circle:before {\n  content: \"\\f059\";\n}\n\n.fa-info-circle:before {\n  content: \"\\f05a\";\n}\n\n.fa-crosshairs:before {\n  content: \"\\f05b\";\n}\n\n.fa-times-circle-o:before {\n  content: \"\\f05c\";\n}\n\n.fa-check-circle-o:before {\n  content: \"\\f05d\";\n}\n\n.fa-ban:before {\n  content: \"\\f05e\";\n}\n\n.fa-arrow-left:before {\n  content: \"\\f060\";\n}\n\n.fa-arrow-right:before {\n  content: \"\\f061\";\n}\n\n.fa-arrow-up:before {\n  content: \"\\f062\";\n}\n\n.fa-arrow-down:before {\n  content: \"\\f063\";\n}\n\n.fa-mail-forward:before,\n.fa-share:before {\n  content: \"\\f064\";\n}\n\n.fa-expand:before {\n  content: \"\\f065\";\n}\n\n.fa-compress:before {\n  content: \"\\f066\";\n}\n\n.fa-plus:before {\n  content: \"\\f067\";\n}\n\n.fa-minus:before {\n  content: \"\\f068\";\n}\n\n.fa-asterisk:before {\n  content: \"\\f069\";\n}\n\n.fa-exclamation-circle:before {\n  content: \"\\f06a\";\n}\n\n.fa-gift:before {\n  content: \"\\f06b\";\n}\n\n.fa-leaf:before {\n  content: \"\\f06c\";\n}\n\n.fa-fire:before {\n  content: \"\\f06d\";\n}\n\n.fa-eye:before {\n  content: \"\\f06e\";\n}\n\n.fa-eye-slash:before {\n  content: \"\\f070\";\n}\n\n.fa-exclamation-triangle:before,\n.fa-warning:before {\n  content: \"\\f071\";\n}\n\n.fa-plane:before {\n  content: \"\\f072\";\n}\n\n.fa-calendar:before {\n  content: \"\\f073\";\n}\n\n.fa-random:before {\n  content: \"\\f074\";\n}\n\n.fa-comment:before {\n  content: \"\\f075\";\n}\n\n.fa-magnet:before {\n  content: \"\\f076\";\n}\n\n.fa-chevron-up:before {\n  content: \"\\f077\";\n}\n\n.fa-chevron-down:before {\n  content: \"\\f078\";\n}\n\n.fa-retweet:before {\n  content: \"\\f079\";\n}\n\n.fa-shopping-cart:before {\n  content: \"\\f07a\";\n}\n\n.fa-folder:before {\n  content: \"\\f07b\";\n}\n\n.fa-folder-open:before {\n  content: \"\\f07c\";\n}\n\n.fa-arrows-v:before {\n  content: \"\\f07d\";\n}\n\n.fa-arrows-h:before {\n  content: \"\\f07e\";\n}\n\n.fa-bar-chart-o:before,\n.fa-bar-chart:before {\n  content: \"\\f080\";\n}\n\n.fa-twitter-square:before {\n  content: \"\\f081\";\n}\n\n.fa-facebook-square:before {\n  content: \"\\f082\";\n}\n\n.fa-camera-retro:before {\n  content: \"\\f083\";\n}\n\n.fa-key:before {\n  content: \"\\f084\";\n}\n\n.fa-cogs:before,\n.fa-gears:before {\n  content: \"\\f085\";\n}\n\n.fa-comments:before {\n  content: \"\\f086\";\n}\n\n.fa-thumbs-o-up:before {\n  content: \"\\f087\";\n}\n\n.fa-thumbs-o-down:before {\n  content: \"\\f088\";\n}\n\n.fa-star-half:before {\n  content: \"\\f089\";\n}\n\n.fa-heart-o:before {\n  content: \"\\f08a\";\n}\n\n.fa-sign-out:before {\n  content: \"\\f08b\";\n}\n\n.fa-linkedin-square:before {\n  content: \"\\f08c\";\n}\n\n.fa-thumb-tack:before {\n  content: \"\\f08d\";\n}\n\n.fa-external-link:before {\n  content: \"\\f08e\";\n}\n\n.fa-sign-in:before {\n  content: \"\\f090\";\n}\n\n.fa-trophy:before {\n  content: \"\\f091\";\n}\n\n.fa-github-square:before {\n  content: \"\\f092\";\n}\n\n.fa-upload:before {\n  content: \"\\f093\";\n}\n\n.fa-lemon-o:before {\n  content: \"\\f094\";\n}\n\n.fa-phone:before {\n  content: \"\\f095\";\n}\n\n.fa-square-o:before {\n  content: \"\\f096\";\n}\n\n.fa-bookmark-o:before {\n  content: \"\\f097\";\n}\n\n.fa-phone-square:before {\n  content: \"\\f098\";\n}\n\n.fa-twitter:before {\n  content: \"\\f099\";\n}\n\n.fa-facebook-f:before,\n.fa-facebook:before {\n  content: \"\\f09a\";\n}\n\n.fa-github:before {\n  content: \"\\f09b\";\n}\n\n.fa-unlock:before {\n  content: \"\\f09c\";\n}\n\n.fa-credit-card:before {\n  content: \"\\f09d\";\n}\n\n.fa-feed:before,\n.fa-rss:before {\n  content: \"\\f09e\";\n}\n\n.fa-hdd-o:before {\n  content: \"\\f0a0\";\n}\n\n.fa-bullhorn:before {\n  content: \"\\f0a1\";\n}\n\n.fa-bell:before {\n  content: \"\\f0f3\";\n}\n\n.fa-certificate:before {\n  content: \"\\f0a3\";\n}\n\n.fa-hand-o-right:before {\n  content: \"\\f0a4\";\n}\n\n.fa-hand-o-left:before {\n  content: \"\\f0a5\";\n}\n\n.fa-hand-o-up:before {\n  content: \"\\f0a6\";\n}\n\n.fa-hand-o-down:before {\n  content: \"\\f0a7\";\n}\n\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\";\n}\n\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\";\n}\n\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\";\n}\n\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\";\n}\n\n.fa-globe:before {\n  content: \"\\f0ac\";\n}\n\n.fa-wrench:before {\n  content: \"\\f0ad\";\n}\n\n.fa-tasks:before {\n  content: \"\\f0ae\";\n}\n\n.fa-filter:before {\n  content: \"\\f0b0\";\n}\n\n.fa-briefcase:before {\n  content: \"\\f0b1\";\n}\n\n.fa-arrows-alt:before {\n  content: \"\\f0b2\";\n}\n\n.fa-group:before,\n.fa-users:before {\n  content: \"\\f0c0\";\n}\n\n.fa-chain:before,\n.fa-link:before {\n  content: \"\\f0c1\";\n}\n\n.fa-cloud:before {\n  content: \"\\f0c2\";\n}\n\n.fa-flask:before {\n  content: \"\\f0c3\";\n}\n\n.fa-cut:before,\n.fa-scissors:before {\n  content: \"\\f0c4\";\n}\n\n.fa-copy:before,\n.fa-files-o:before {\n  content: \"\\f0c5\";\n}\n\n.fa-paperclip:before {\n  content: \"\\f0c6\";\n}\n\n.fa-floppy-o:before,\n.fa-save:before {\n  content: \"\\f0c7\";\n}\n\n.fa-square:before {\n  content: \"\\f0c8\";\n}\n\n.fa-bars:before,\n.fa-navicon:before,\n.fa-reorder:before {\n  content: \"\\f0c9\";\n}\n\n.fa-list-ul:before {\n  content: \"\\f0ca\";\n}\n\n.fa-list-ol:before {\n  content: \"\\f0cb\";\n}\n\n.fa-strikethrough:before {\n  content: \"\\f0cc\";\n}\n\n.fa-underline:before {\n  content: \"\\f0cd\";\n}\n\n.fa-table:before {\n  content: \"\\f0ce\";\n}\n\n.fa-magic:before {\n  content: \"\\f0d0\";\n}\n\n.fa-truck:before {\n  content: \"\\f0d1\";\n}\n\n.fa-pinterest:before {\n  content: \"\\f0d2\";\n}\n\n.fa-pinterest-square:before {\n  content: \"\\f0d3\";\n}\n\n.fa-google-plus-square:before {\n  content: \"\\f0d4\";\n}\n\n.fa-google-plus:before {\n  content: \"\\f0d5\";\n}\n\n.fa-money:before {\n  content: \"\\f0d6\";\n}\n\n.fa-caret-down:before {\n  content: \"\\f0d7\";\n}\n\n.fa-caret-up:before {\n  content: \"\\f0d8\";\n}\n\n.fa-caret-left:before {\n  content: \"\\f0d9\";\n}\n\n.fa-caret-right:before {\n  content: \"\\f0da\";\n}\n\n.fa-columns:before {\n  content: \"\\f0db\";\n}\n\n.fa-sort:before,\n.fa-unsorted:before {\n  content: \"\\f0dc\";\n}\n\n.fa-sort-desc:before,\n.fa-sort-down:before {\n  content: \"\\f0dd\";\n}\n\n.fa-sort-asc:before,\n.fa-sort-up:before {\n  content: \"\\f0de\";\n}\n\n.fa-envelope:before {\n  content: \"\\f0e0\";\n}\n\n.fa-linkedin:before {\n  content: \"\\f0e1\";\n}\n\n.fa-rotate-left:before,\n.fa-undo:before {\n  content: \"\\f0e2\";\n}\n\n.fa-gavel:before,\n.fa-legal:before {\n  content: \"\\f0e3\";\n}\n\n.fa-dashboard:before,\n.fa-tachometer:before {\n  content: \"\\f0e4\";\n}\n\n.fa-comment-o:before {\n  content: \"\\f0e5\";\n}\n\n.fa-comments-o:before {\n  content: \"\\f0e6\";\n}\n\n.fa-bolt:before,\n.fa-flash:before {\n  content: \"\\f0e7\";\n}\n\n.fa-sitemap:before {\n  content: \"\\f0e8\";\n}\n\n.fa-umbrella:before {\n  content: \"\\f0e9\";\n}\n\n.fa-clipboard:before,\n.fa-paste:before {\n  content: \"\\f0ea\";\n}\n\n.fa-lightbulb-o:before {\n  content: \"\\f0eb\";\n}\n\n.fa-exchange:before {\n  content: \"\\f0ec\";\n}\n\n.fa-cloud-download:before {\n  content: \"\\f0ed\";\n}\n\n.fa-cloud-upload:before {\n  content: \"\\f0ee\";\n}\n\n.fa-user-md:before {\n  content: \"\\f0f0\";\n}\n\n.fa-stethoscope:before {\n  content: \"\\f0f1\";\n}\n\n.fa-suitcase:before {\n  content: \"\\f0f2\";\n}\n\n.fa-bell-o:before {\n  content: \"\\f0a2\";\n}\n\n.fa-coffee:before {\n  content: \"\\f0f4\";\n}\n\n.fa-cutlery:before {\n  content: \"\\f0f5\";\n}\n\n.fa-file-text-o:before {\n  content: \"\\f0f6\";\n}\n\n.fa-building-o:before {\n  content: \"\\f0f7\";\n}\n\n.fa-hospital-o:before {\n  content: \"\\f0f8\";\n}\n\n.fa-ambulance:before {\n  content: \"\\f0f9\";\n}\n\n.fa-medkit:before {\n  content: \"\\f0fa\";\n}\n\n.fa-fighter-jet:before {\n  content: \"\\f0fb\";\n}\n\n.fa-beer:before {\n  content: \"\\f0fc\";\n}\n\n.fa-h-square:before {\n  content: \"\\f0fd\";\n}\n\n.fa-plus-square:before {\n  content: \"\\f0fe\";\n}\n\n.fa-angle-double-left:before {\n  content: \"\\f100\";\n}\n\n.fa-angle-double-right:before {\n  content: \"\\f101\";\n}\n\n.fa-angle-double-up:before {\n  content: \"\\f102\";\n}\n\n.fa-angle-double-down:before {\n  content: \"\\f103\";\n}\n\n.fa-angle-left:before {\n  content: \"\\f104\";\n}\n\n.fa-angle-right:before {\n  content: \"\\f105\";\n}\n\n.fa-angle-up:before {\n  content: \"\\f106\";\n}\n\n.fa-angle-down:before {\n  content: \"\\f107\";\n}\n\n.fa-desktop:before {\n  content: \"\\f108\";\n}\n\n.fa-laptop:before {\n  content: \"\\f109\";\n}\n\n.fa-tablet:before {\n  content: \"\\f10a\";\n}\n\n.fa-mobile-phone:before,\n.fa-mobile:before {\n  content: \"\\f10b\";\n}\n\n.fa-circle-o:before {\n  content: \"\\f10c\";\n}\n\n.fa-quote-left:before {\n  content: \"\\f10d\";\n}\n\n.fa-quote-right:before {\n  content: \"\\f10e\";\n}\n\n.fa-spinner:before {\n  content: \"\\f110\";\n}\n\n.fa-circle:before {\n  content: \"\\f111\";\n}\n\n.fa-mail-reply:before,\n.fa-reply:before {\n  content: \"\\f112\";\n}\n\n.fa-github-alt:before {\n  content: \"\\f113\";\n}\n\n.fa-folder-o:before {\n  content: \"\\f114\";\n}\n\n.fa-folder-open-o:before {\n  content: \"\\f115\";\n}\n\n.fa-smile-o:before {\n  content: \"\\f118\";\n}\n\n.fa-frown-o:before {\n  content: \"\\f119\";\n}\n\n.fa-meh-o:before {\n  content: \"\\f11a\";\n}\n\n.fa-gamepad:before {\n  content: \"\\f11b\";\n}\n\n.fa-keyboard-o:before {\n  content: \"\\f11c\";\n}\n\n.fa-flag-o:before {\n  content: \"\\f11d\";\n}\n\n.fa-flag-checkered:before {\n  content: \"\\f11e\";\n}\n\n.fa-terminal:before {\n  content: \"\\f120\";\n}\n\n.fa-code:before {\n  content: \"\\f121\";\n}\n\n.fa-mail-reply-all:before,\n.fa-reply-all:before {\n  content: \"\\f122\";\n}\n\n.fa-star-half-empty:before,\n.fa-star-half-full:before,\n.fa-star-half-o:before {\n  content: \"\\f123\";\n}\n\n.fa-location-arrow:before {\n  content: \"\\f124\";\n}\n\n.fa-crop:before {\n  content: \"\\f125\";\n}\n\n.fa-code-fork:before {\n  content: \"\\f126\";\n}\n\n.fa-chain-broken:before,\n.fa-unlink:before {\n  content: \"\\f127\";\n}\n\n.fa-question:before {\n  content: \"\\f128\";\n}\n\n.fa-info:before {\n  content: \"\\f129\";\n}\n\n.fa-exclamation:before {\n  content: \"\\f12a\";\n}\n\n.fa-superscript:before {\n  content: \"\\f12b\";\n}\n\n.fa-subscript:before {\n  content: \"\\f12c\";\n}\n\n.fa-eraser:before {\n  content: \"\\f12d\";\n}\n\n.fa-puzzle-piece:before {\n  content: \"\\f12e\";\n}\n\n.fa-microphone:before {\n  content: \"\\f130\";\n}\n\n.fa-microphone-slash:before {\n  content: \"\\f131\";\n}\n\n.fa-shield:before {\n  content: \"\\f132\";\n}\n\n.fa-calendar-o:before {\n  content: \"\\f133\";\n}\n\n.fa-fire-extinguisher:before {\n  content: \"\\f134\";\n}\n\n.fa-rocket:before {\n  content: \"\\f135\";\n}\n\n.fa-maxcdn:before {\n  content: \"\\f136\";\n}\n\n.fa-chevron-circle-left:before {\n  content: \"\\f137\";\n}\n\n.fa-chevron-circle-right:before {\n  content: \"\\f138\";\n}\n\n.fa-chevron-circle-up:before {\n  content: \"\\f139\";\n}\n\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\";\n}\n\n.fa-html5:before {\n  content: \"\\f13b\";\n}\n\n.fa-css3:before {\n  content: \"\\f13c\";\n}\n\n.fa-anchor:before {\n  content: \"\\f13d\";\n}\n\n.fa-unlock-alt:before {\n  content: \"\\f13e\";\n}\n\n.fa-bullseye:before {\n  content: \"\\f140\";\n}\n\n.fa-ellipsis-h:before {\n  content: \"\\f141\";\n}\n\n.fa-ellipsis-v:before {\n  content: \"\\f142\";\n}\n\n.fa-rss-square:before {\n  content: \"\\f143\";\n}\n\n.fa-play-circle:before {\n  content: \"\\f144\";\n}\n\n.fa-ticket:before {\n  content: \"\\f145\";\n}\n\n.fa-minus-square:before {\n  content: \"\\f146\";\n}\n\n.fa-minus-square-o:before {\n  content: \"\\f147\";\n}\n\n.fa-level-up:before {\n  content: \"\\f148\";\n}\n\n.fa-level-down:before {\n  content: \"\\f149\";\n}\n\n.fa-check-square:before {\n  content: \"\\f14a\";\n}\n\n.fa-pencil-square:before {\n  content: \"\\f14b\";\n}\n\n.fa-external-link-square:before {\n  content: \"\\f14c\";\n}\n\n.fa-share-square:before {\n  content: \"\\f14d\";\n}\n\n.fa-compass:before {\n  content: \"\\f14e\";\n}\n\n.fa-caret-square-o-down:before,\n.fa-toggle-down:before {\n  content: \"\\f150\";\n}\n\n.fa-caret-square-o-up:before,\n.fa-toggle-up:before {\n  content: \"\\f151\";\n}\n\n.fa-caret-square-o-right:before,\n.fa-toggle-right:before {\n  content: \"\\f152\";\n}\n\n.fa-eur:before,\n.fa-euro:before {\n  content: \"\\f153\";\n}\n\n.fa-gbp:before {\n  content: \"\\f154\";\n}\n\n.fa-dollar:before,\n.fa-usd:before {\n  content: \"\\f155\";\n}\n\n.fa-inr:before,\n.fa-rupee:before {\n  content: \"\\f156\";\n}\n\n.fa-cny:before,\n.fa-jpy:before,\n.fa-rmb:before,\n.fa-yen:before {\n  content: \"\\f157\";\n}\n\n.fa-rouble:before,\n.fa-rub:before,\n.fa-ruble:before {\n  content: \"\\f158\";\n}\n\n.fa-krw:before,\n.fa-won:before {\n  content: \"\\f159\";\n}\n\n.fa-bitcoin:before,\n.fa-btc:before {\n  content: \"\\f15a\";\n}\n\n.fa-file:before {\n  content: \"\\f15b\";\n}\n\n.fa-file-text:before {\n  content: \"\\f15c\";\n}\n\n.fa-sort-alpha-asc:before {\n  content: \"\\f15d\";\n}\n\n.fa-sort-alpha-desc:before {\n  content: \"\\f15e\";\n}\n\n.fa-sort-amount-asc:before {\n  content: \"\\f160\";\n}\n\n.fa-sort-amount-desc:before {\n  content: \"\\f161\";\n}\n\n.fa-sort-numeric-asc:before {\n  content: \"\\f162\";\n}\n\n.fa-sort-numeric-desc:before {\n  content: \"\\f163\";\n}\n\n.fa-thumbs-up:before {\n  content: \"\\f164\";\n}\n\n.fa-thumbs-down:before {\n  content: \"\\f165\";\n}\n\n.fa-youtube-square:before {\n  content: \"\\f166\";\n}\n\n.fa-youtube:before {\n  content: \"\\f167\";\n}\n\n.fa-xing:before {\n  content: \"\\f168\";\n}\n\n.fa-xing-square:before {\n  content: \"\\f169\";\n}\n\n.fa-youtube-play:before {\n  content: \"\\f16a\";\n}\n\n.fa-dropbox:before {\n  content: \"\\f16b\";\n}\n\n.fa-stack-overflow:before {\n  content: \"\\f16c\";\n}\n\n.fa-instagram:before {\n  content: \"\\f16d\";\n}\n\n.fa-flickr:before {\n  content: \"\\f16e\";\n}\n\n.fa-adn:before {\n  content: \"\\f170\";\n}\n\n.fa-bitbucket:before {\n  content: \"\\f171\";\n}\n\n.fa-bitbucket-square:before {\n  content: \"\\f172\";\n}\n\n.fa-tumblr:before {\n  content: \"\\f173\";\n}\n\n.fa-tumblr-square:before {\n  content: \"\\f174\";\n}\n\n.fa-long-arrow-down:before {\n  content: \"\\f175\";\n}\n\n.fa-long-arrow-up:before {\n  content: \"\\f176\";\n}\n\n.fa-long-arrow-left:before {\n  content: \"\\f177\";\n}\n\n.fa-long-arrow-right:before {\n  content: \"\\f178\";\n}\n\n.fa-apple:before {\n  content: \"\\f179\";\n}\n\n.fa-windows:before {\n  content: \"\\f17a\";\n}\n\n.fa-android:before {\n  content: \"\\f17b\";\n}\n\n.fa-linux:before {\n  content: \"\\f17c\";\n}\n\n.fa-dribbble:before {\n  content: \"\\f17d\";\n}\n\n.fa-skype:before {\n  content: \"\\f17e\";\n}\n\n.fa-foursquare:before {\n  content: \"\\f180\";\n}\n\n.fa-trello:before {\n  content: \"\\f181\";\n}\n\n.fa-female:before {\n  content: \"\\f182\";\n}\n\n.fa-male:before {\n  content: \"\\f183\";\n}\n\n.fa-gittip:before,\n.fa-gratipay:before {\n  content: \"\\f184\";\n}\n\n.fa-sun-o:before {\n  content: \"\\f185\";\n}\n\n.fa-moon-o:before {\n  content: \"\\f186\";\n}\n\n.fa-archive:before {\n  content: \"\\f187\";\n}\n\n.fa-bug:before {\n  content: \"\\f188\";\n}\n\n.fa-vk:before {\n  content: \"\\f189\";\n}\n\n.fa-weibo:before {\n  content: \"\\f18a\";\n}\n\n.fa-renren:before {\n  content: \"\\f18b\";\n}\n\n.fa-pagelines:before {\n  content: \"\\f18c\";\n}\n\n.fa-stack-exchange:before {\n  content: \"\\f18d\";\n}\n\n.fa-arrow-circle-o-right:before {\n  content: \"\\f18e\";\n}\n\n.fa-arrow-circle-o-left:before {\n  content: \"\\f190\";\n}\n\n.fa-caret-square-o-left:before,\n.fa-toggle-left:before {\n  content: \"\\f191\";\n}\n\n.fa-dot-circle-o:before {\n  content: \"\\f192\";\n}\n\n.fa-wheelchair:before {\n  content: \"\\f193\";\n}\n\n.fa-vimeo-square:before {\n  content: \"\\f194\";\n}\n\n.fa-try:before,\n.fa-turkish-lira:before {\n  content: \"\\f195\";\n}\n\n.fa-plus-square-o:before {\n  content: \"\\f196\";\n}\n\n.fa-space-shuttle:before {\n  content: \"\\f197\";\n}\n\n.fa-slack:before {\n  content: \"\\f198\";\n}\n\n.fa-envelope-square:before {\n  content: \"\\f199\";\n}\n\n.fa-wordpress:before {\n  content: \"\\f19a\";\n}\n\n.fa-openid:before {\n  content: \"\\f19b\";\n}\n\n.fa-bank:before,\n.fa-institution:before,\n.fa-university:before {\n  content: \"\\f19c\";\n}\n\n.fa-graduation-cap:before,\n.fa-mortar-board:before {\n  content: \"\\f19d\";\n}\n\n.fa-yahoo:before {\n  content: \"\\f19e\";\n}\n\n.fa-google:before {\n  content: \"\\f1a0\";\n}\n\n.fa-reddit:before {\n  content: \"\\f1a1\";\n}\n\n.fa-reddit-square:before {\n  content: \"\\f1a2\";\n}\n\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\";\n}\n\n.fa-stumbleupon:before {\n  content: \"\\f1a4\";\n}\n\n.fa-delicious:before {\n  content: \"\\f1a5\";\n}\n\n.fa-digg:before {\n  content: \"\\f1a6\";\n}\n\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\";\n}\n\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\";\n}\n\n.fa-drupal:before {\n  content: \"\\f1a9\";\n}\n\n.fa-joomla:before {\n  content: \"\\f1aa\";\n}\n\n.fa-language:before {\n  content: \"\\f1ab\";\n}\n\n.fa-fax:before {\n  content: \"\\f1ac\";\n}\n\n.fa-building:before {\n  content: \"\\f1ad\";\n}\n\n.fa-child:before {\n  content: \"\\f1ae\";\n}\n\n.fa-paw:before {\n  content: \"\\f1b0\";\n}\n\n.fa-spoon:before {\n  content: \"\\f1b1\";\n}\n\n.fa-cube:before {\n  content: \"\\f1b2\";\n}\n\n.fa-cubes:before {\n  content: \"\\f1b3\";\n}\n\n.fa-behance:before {\n  content: \"\\f1b4\";\n}\n\n.fa-behance-square:before {\n  content: \"\\f1b5\";\n}\n\n.fa-steam:before {\n  content: \"\\f1b6\";\n}\n\n.fa-steam-square:before {\n  content: \"\\f1b7\";\n}\n\n.fa-recycle:before {\n  content: \"\\f1b8\";\n}\n\n.fa-automobile:before,\n.fa-car:before {\n  content: \"\\f1b9\";\n}\n\n.fa-cab:before,\n.fa-taxi:before {\n  content: \"\\f1ba\";\n}\n\n.fa-tree:before {\n  content: \"\\f1bb\";\n}\n\n.fa-spotify:before {\n  content: \"\\f1bc\";\n}\n\n.fa-deviantart:before {\n  content: \"\\f1bd\";\n}\n\n.fa-soundcloud:before {\n  content: \"\\f1be\";\n}\n\n.fa-database:before {\n  content: \"\\f1c0\";\n}\n\n.fa-file-pdf-o:before {\n  content: \"\\f1c1\";\n}\n\n.fa-file-word-o:before {\n  content: \"\\f1c2\";\n}\n\n.fa-file-excel-o:before {\n  content: \"\\f1c3\";\n}\n\n.fa-file-powerpoint-o:before {\n  content: \"\\f1c4\";\n}\n\n.fa-file-image-o:before,\n.fa-file-photo-o:before,\n.fa-file-picture-o:before {\n  content: \"\\f1c5\";\n}\n\n.fa-file-archive-o:before,\n.fa-file-zip-o:before {\n  content: \"\\f1c6\";\n}\n\n.fa-file-audio-o:before,\n.fa-file-sound-o:before {\n  content: \"\\f1c7\";\n}\n\n.fa-file-movie-o:before,\n.fa-file-video-o:before {\n  content: \"\\f1c8\";\n}\n\n.fa-file-code-o:before {\n  content: \"\\f1c9\";\n}\n\n.fa-vine:before {\n  content: \"\\f1ca\";\n}\n\n.fa-codepen:before {\n  content: \"\\f1cb\";\n}\n\n.fa-jsfiddle:before {\n  content: \"\\f1cc\";\n}\n\n.fa-life-bouy:before,\n.fa-life-buoy:before,\n.fa-life-ring:before,\n.fa-life-saver:before,\n.fa-support:before {\n  content: \"\\f1cd\";\n}\n\n.fa-circle-o-notch:before {\n  content: \"\\f1ce\";\n}\n\n.fa-ra:before,\n.fa-rebel:before,\n.fa-resistance:before {\n  content: \"\\f1d0\";\n}\n\n.fa-empire:before,\n.fa-ge:before {\n  content: \"\\f1d1\";\n}\n\n.fa-git-square:before {\n  content: \"\\f1d2\";\n}\n\n.fa-git:before {\n  content: \"\\f1d3\";\n}\n\n.fa-hacker-news:before,\n.fa-y-combinator-square:before,\n.fa-yc-square:before {\n  content: \"\\f1d4\";\n}\n\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\";\n}\n\n.fa-qq:before {\n  content: \"\\f1d6\";\n}\n\n.fa-wechat:before,\n.fa-weixin:before {\n  content: \"\\f1d7\";\n}\n\n.fa-paper-plane:before,\n.fa-send:before {\n  content: \"\\f1d8\";\n}\n\n.fa-paper-plane-o:before,\n.fa-send-o:before {\n  content: \"\\f1d9\";\n}\n\n.fa-history:before {\n  content: \"\\f1da\";\n}\n\n.fa-circle-thin:before {\n  content: \"\\f1db\";\n}\n\n.fa-header:before {\n  content: \"\\f1dc\";\n}\n\n.fa-paragraph:before {\n  content: \"\\f1dd\";\n}\n\n.fa-sliders:before {\n  content: \"\\f1de\";\n}\n\n.fa-share-alt:before {\n  content: \"\\f1e0\";\n}\n\n.fa-share-alt-square:before {\n  content: \"\\f1e1\";\n}\n\n.fa-bomb:before {\n  content: \"\\f1e2\";\n}\n\n.fa-futbol-o:before,\n.fa-soccer-ball-o:before {\n  content: \"\\f1e3\";\n}\n\n.fa-tty:before {\n  content: \"\\f1e4\";\n}\n\n.fa-binoculars:before {\n  content: \"\\f1e5\";\n}\n\n.fa-plug:before {\n  content: \"\\f1e6\";\n}\n\n.fa-slideshare:before {\n  content: \"\\f1e7\";\n}\n\n.fa-twitch:before {\n  content: \"\\f1e8\";\n}\n\n.fa-yelp:before {\n  content: \"\\f1e9\";\n}\n\n.fa-newspaper-o:before {\n  content: \"\\f1ea\";\n}\n\n.fa-wifi:before {\n  content: \"\\f1eb\";\n}\n\n.fa-calculator:before {\n  content: \"\\f1ec\";\n}\n\n.fa-paypal:before {\n  content: \"\\f1ed\";\n}\n\n.fa-google-wallet:before {\n  content: \"\\f1ee\";\n}\n\n.fa-cc-visa:before {\n  content: \"\\f1f0\";\n}\n\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\";\n}\n\n.fa-cc-discover:before {\n  content: \"\\f1f2\";\n}\n\n.fa-cc-amex:before {\n  content: \"\\f1f3\";\n}\n\n.fa-cc-paypal:before {\n  content: \"\\f1f4\";\n}\n\n.fa-cc-stripe:before {\n  content: \"\\f1f5\";\n}\n\n.fa-bell-slash:before {\n  content: \"\\f1f6\";\n}\n\n.fa-bell-slash-o:before {\n  content: \"\\f1f7\";\n}\n\n.fa-trash:before {\n  content: \"\\f1f8\";\n}\n\n.fa-copyright:before {\n  content: \"\\f1f9\";\n}\n\n.fa-at:before {\n  content: \"\\f1fa\";\n}\n\n.fa-eyedropper:before {\n  content: \"\\f1fb\";\n}\n\n.fa-paint-brush:before {\n  content: \"\\f1fc\";\n}\n\n.fa-birthday-cake:before {\n  content: \"\\f1fd\";\n}\n\n.fa-area-chart:before {\n  content: \"\\f1fe\";\n}\n\n.fa-pie-chart:before {\n  content: \"\\f200\";\n}\n\n.fa-line-chart:before {\n  content: \"\\f201\";\n}\n\n.fa-lastfm:before {\n  content: \"\\f202\";\n}\n\n.fa-lastfm-square:before {\n  content: \"\\f203\";\n}\n\n.fa-toggle-off:before {\n  content: \"\\f204\";\n}\n\n.fa-toggle-on:before {\n  content: \"\\f205\";\n}\n\n.fa-bicycle:before {\n  content: \"\\f206\";\n}\n\n.fa-bus:before {\n  content: \"\\f207\";\n}\n\n.fa-ioxhost:before {\n  content: \"\\f208\";\n}\n\n.fa-angellist:before {\n  content: \"\\f209\";\n}\n\n.fa-cc:before {\n  content: \"\\f20a\";\n}\n\n.fa-ils:before,\n.fa-shekel:before,\n.fa-sheqel:before {\n  content: \"\\f20b\";\n}\n\n.fa-meanpath:before {\n  content: \"\\f20c\";\n}\n\n.fa-buysellads:before {\n  content: \"\\f20d\";\n}\n\n.fa-connectdevelop:before {\n  content: \"\\f20e\";\n}\n\n.fa-dashcube:before {\n  content: \"\\f210\";\n}\n\n.fa-forumbee:before {\n  content: \"\\f211\";\n}\n\n.fa-leanpub:before {\n  content: \"\\f212\";\n}\n\n.fa-sellsy:before {\n  content: \"\\f213\";\n}\n\n.fa-shirtsinbulk:before {\n  content: \"\\f214\";\n}\n\n.fa-simplybuilt:before {\n  content: \"\\f215\";\n}\n\n.fa-skyatlas:before {\n  content: \"\\f216\";\n}\n\n.fa-cart-plus:before {\n  content: \"\\f217\";\n}\n\n.fa-cart-arrow-down:before {\n  content: \"\\f218\";\n}\n\n.fa-diamond:before {\n  content: \"\\f219\";\n}\n\n.fa-ship:before {\n  content: \"\\f21a\";\n}\n\n.fa-user-secret:before {\n  content: \"\\f21b\";\n}\n\n.fa-motorcycle:before {\n  content: \"\\f21c\";\n}\n\n.fa-street-view:before {\n  content: \"\\f21d\";\n}\n\n.fa-heartbeat:before {\n  content: \"\\f21e\";\n}\n\n.fa-venus:before {\n  content: \"\\f221\";\n}\n\n.fa-mars:before {\n  content: \"\\f222\";\n}\n\n.fa-mercury:before {\n  content: \"\\f223\";\n}\n\n.fa-intersex:before,\n.fa-transgender:before {\n  content: \"\\f224\";\n}\n\n.fa-transgender-alt:before {\n  content: \"\\f225\";\n}\n\n.fa-venus-double:before {\n  content: \"\\f226\";\n}\n\n.fa-mars-double:before {\n  content: \"\\f227\";\n}\n\n.fa-venus-mars:before {\n  content: \"\\f228\";\n}\n\n.fa-mars-stroke:before {\n  content: \"\\f229\";\n}\n\n.fa-mars-stroke-v:before {\n  content: \"\\f22a\";\n}\n\n.fa-mars-stroke-h:before {\n  content: \"\\f22b\";\n}\n\n.fa-neuter:before {\n  content: \"\\f22c\";\n}\n\n.fa-genderless:before {\n  content: \"\\f22d\";\n}\n\n.fa-facebook-official:before {\n  content: \"\\f230\";\n}\n\n.fa-pinterest-p:before {\n  content: \"\\f231\";\n}\n\n.fa-whatsapp:before {\n  content: \"\\f232\";\n}\n\n.fa-server:before {\n  content: \"\\f233\";\n}\n\n.fa-user-plus:before {\n  content: \"\\f234\";\n}\n\n.fa-user-times:before {\n  content: \"\\f235\";\n}\n\n.fa-bed:before,\n.fa-hotel:before {\n  content: \"\\f236\";\n}\n\n.fa-viacoin:before {\n  content: \"\\f237\";\n}\n\n.fa-train:before {\n  content: \"\\f238\";\n}\n\n.fa-subway:before {\n  content: \"\\f239\";\n}\n\n.fa-medium:before {\n  content: \"\\f23a\";\n}\n\n.fa-y-combinator:before,\n.fa-yc:before {\n  content: \"\\f23b\";\n}\n\n.fa-optin-monster:before {\n  content: \"\\f23c\";\n}\n\n.fa-opencart:before {\n  content: \"\\f23d\";\n}\n\n.fa-expeditedssl:before {\n  content: \"\\f23e\";\n}\n\n.fa-battery-4:before,\n.fa-battery-full:before,\n.fa-battery:before {\n  content: \"\\f240\";\n}\n\n.fa-battery-3:before,\n.fa-battery-three-quarters:before {\n  content: \"\\f241\";\n}\n\n.fa-battery-2:before,\n.fa-battery-half:before {\n  content: \"\\f242\";\n}\n\n.fa-battery-1:before,\n.fa-battery-quarter:before {\n  content: \"\\f243\";\n}\n\n.fa-battery-0:before,\n.fa-battery-empty:before {\n  content: \"\\f244\";\n}\n\n.fa-mouse-pointer:before {\n  content: \"\\f245\";\n}\n\n.fa-i-cursor:before {\n  content: \"\\f246\";\n}\n\n.fa-object-group:before {\n  content: \"\\f247\";\n}\n\n.fa-object-ungroup:before {\n  content: \"\\f248\";\n}\n\n.fa-sticky-note:before {\n  content: \"\\f249\";\n}\n\n.fa-sticky-note-o:before {\n  content: \"\\f24a\";\n}\n\n.fa-cc-jcb:before {\n  content: \"\\f24b\";\n}\n\n.fa-cc-diners-club:before {\n  content: \"\\f24c\";\n}\n\n.fa-clone:before {\n  content: \"\\f24d\";\n}\n\n.fa-balance-scale:before {\n  content: \"\\f24e\";\n}\n\n.fa-hourglass-o:before {\n  content: \"\\f250\";\n}\n\n.fa-hourglass-1:before,\n.fa-hourglass-start:before {\n  content: \"\\f251\";\n}\n\n.fa-hourglass-2:before,\n.fa-hourglass-half:before {\n  content: \"\\f252\";\n}\n\n.fa-hourglass-3:before,\n.fa-hourglass-end:before {\n  content: \"\\f253\";\n}\n\n.fa-hourglass:before {\n  content: \"\\f254\";\n}\n\n.fa-hand-grab-o:before,\n.fa-hand-rock-o:before {\n  content: \"\\f255\";\n}\n\n.fa-hand-paper-o:before,\n.fa-hand-stop-o:before {\n  content: \"\\f256\";\n}\n\n.fa-hand-scissors-o:before {\n  content: \"\\f257\";\n}\n\n.fa-hand-lizard-o:before {\n  content: \"\\f258\";\n}\n\n.fa-hand-spock-o:before {\n  content: \"\\f259\";\n}\n\n.fa-hand-pointer-o:before {\n  content: \"\\f25a\";\n}\n\n.fa-hand-peace-o:before {\n  content: \"\\f25b\";\n}\n\n.fa-trademark:before {\n  content: \"\\f25c\";\n}\n\n.fa-registered:before {\n  content: \"\\f25d\";\n}\n\n.fa-creative-commons:before {\n  content: \"\\f25e\";\n}\n\n.fa-gg:before {\n  content: \"\\f260\";\n}\n\n.fa-gg-circle:before {\n  content: \"\\f261\";\n}\n\n.fa-tripadvisor:before {\n  content: \"\\f262\";\n}\n\n.fa-odnoklassniki:before {\n  content: \"\\f263\";\n}\n\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\";\n}\n\n.fa-get-pocket:before {\n  content: \"\\f265\";\n}\n\n.fa-wikipedia-w:before {\n  content: \"\\f266\";\n}\n\n.fa-safari:before {\n  content: \"\\f267\";\n}\n\n.fa-chrome:before {\n  content: \"\\f268\";\n}\n\n.fa-firefox:before {\n  content: \"\\f269\";\n}\n\n.fa-opera:before {\n  content: \"\\f26a\";\n}\n\n.fa-internet-explorer:before {\n  content: \"\\f26b\";\n}\n\n.fa-television:before,\n.fa-tv:before {\n  content: \"\\f26c\";\n}\n\n.fa-contao:before {\n  content: \"\\f26d\";\n}\n\n.fa-500px:before {\n  content: \"\\f26e\";\n}\n\n.fa-amazon:before {\n  content: \"\\f270\";\n}\n\n.fa-calendar-plus-o:before {\n  content: \"\\f271\";\n}\n\n.fa-calendar-minus-o:before {\n  content: \"\\f272\";\n}\n\n.fa-calendar-times-o:before {\n  content: \"\\f273\";\n}\n\n.fa-calendar-check-o:before {\n  content: \"\\f274\";\n}\n\n.fa-industry:before {\n  content: \"\\f275\";\n}\n\n.fa-map-pin:before {\n  content: \"\\f276\";\n}\n\n.fa-map-signs:before {\n  content: \"\\f277\";\n}\n\n.fa-map-o:before {\n  content: \"\\f278\";\n}\n\n.fa-map:before {\n  content: \"\\f279\";\n}\n\n.fa-commenting:before {\n  content: \"\\f27a\";\n}\n\n.fa-commenting-o:before {\n  content: \"\\f27b\";\n}\n\n.fa-houzz:before {\n  content: \"\\f27c\";\n}\n\n.fa-vimeo:before {\n  content: \"\\f27d\";\n}\n\n.fa-black-tie:before {\n  content: \"\\f27e\";\n}\n\n.fa-fonticons:before {\n  content: \"\\f280\";\n}\n\n.fa-reddit-alien:before {\n  content: \"\\f281\";\n}\n\n.fa-edge:before {\n  content: \"\\f282\";\n}\n\n.fa-credit-card-alt:before {\n  content: \"\\f283\";\n}\n\n.fa-codiepie:before {\n  content: \"\\f284\";\n}\n\n.fa-modx:before {\n  content: \"\\f285\";\n}\n\n.fa-fort-awesome:before {\n  content: \"\\f286\";\n}\n\n.fa-usb:before {\n  content: \"\\f287\";\n}\n\n.fa-product-hunt:before {\n  content: \"\\f288\";\n}\n\n.fa-mixcloud:before {\n  content: \"\\f289\";\n}\n\n.fa-scribd:before {\n  content: \"\\f28a\";\n}\n\n.fa-pause-circle:before {\n  content: \"\\f28b\";\n}\n\n.fa-pause-circle-o:before {\n  content: \"\\f28c\";\n}\n\n.fa-stop-circle:before {\n  content: \"\\f28d\";\n}\n\n.fa-stop-circle-o:before {\n  content: \"\\f28e\";\n}\n\n.fa-shopping-bag:before {\n  content: \"\\f290\";\n}\n\n.fa-shopping-basket:before {\n  content: \"\\f291\";\n}\n\n.fa-hashtag:before {\n  content: \"\\f292\";\n}\n\n.fa-bluetooth:before {\n  content: \"\\f293\";\n}\n\n.fa-bluetooth-b:before {\n  content: \"\\f294\";\n}\n\n.fa-percent:before {\n  content: \"\\f295\";\n}\n\n.fa-gitlab:before {\n  content: \"\\f296\";\n}\n\n.fa-wpbeginner:before {\n  content: \"\\f297\";\n}\n\n.fa-wpforms:before {\n  content: \"\\f298\";\n}\n\n.fa-envira:before {\n  content: \"\\f299\";\n}\n\n.fa-universal-access:before {\n  content: \"\\f29a\";\n}\n\n.fa-wheelchair-alt:before {\n  content: \"\\f29b\";\n}\n\n.fa-question-circle-o:before {\n  content: \"\\f29c\";\n}\n\n.fa-blind:before {\n  content: \"\\f29d\";\n}\n\n.fa-audio-description:before {\n  content: \"\\f29e\";\n}\n\n.fa-volume-control-phone:before {\n  content: \"\\f2a0\";\n}\n\n.fa-braille:before {\n  content: \"\\f2a1\";\n}\n\n.fa-assistive-listening-systems:before {\n  content: \"\\f2a2\";\n}\n\n.fa-american-sign-language-interpreting:before,\n.fa-asl-interpreting:before {\n  content: \"\\f2a3\";\n}\n\n.fa-deaf:before,\n.fa-deafness:before,\n.fa-hard-of-hearing:before {\n  content: \"\\f2a4\";\n}\n\n.fa-glide:before {\n  content: \"\\f2a5\";\n}\n\n.fa-glide-g:before {\n  content: \"\\f2a6\";\n}\n\n.fa-sign-language:before,\n.fa-signing:before {\n  content: \"\\f2a7\";\n}\n\n.fa-low-vision:before {\n  content: \"\\f2a8\";\n}\n\n.fa-viadeo:before {\n  content: \"\\f2a9\";\n}\n\n.fa-viadeo-square:before {\n  content: \"\\f2aa\";\n}\n\n.fa-snapchat:before {\n  content: \"\\f2ab\";\n}\n\n.fa-snapchat-ghost:before {\n  content: \"\\f2ac\";\n}\n\n.fa-snapchat-square:before {\n  content: \"\\f2ad\";\n}\n\n.fa-pied-piper:before {\n  content: \"\\f2ae\";\n}\n\n.fa-first-order:before {\n  content: \"\\f2b0\";\n}\n\n.fa-yoast:before {\n  content: \"\\f2b1\";\n}\n\n.fa-themeisle:before {\n  content: \"\\f2b2\";\n}\n\n.fa-google-plus-circle:before,\n.fa-google-plus-official:before {\n  content: \"\\f2b3\";\n}\n\n.fa-fa:before,\n.fa-font-awesome:before {\n  content: \"\\f2b4\";\n}\n\n.fa-handshake-o:before {\n  content: \"\\f2b5\";\n}\n\n.fa-envelope-open:before {\n  content: \"\\f2b6\";\n}\n\n.fa-envelope-open-o:before {\n  content: \"\\f2b7\";\n}\n\n.fa-linode:before {\n  content: \"\\f2b8\";\n}\n\n.fa-address-book:before {\n  content: \"\\f2b9\";\n}\n\n.fa-address-book-o:before {\n  content: \"\\f2ba\";\n}\n\n.fa-address-card:before,\n.fa-vcard:before {\n  content: \"\\f2bb\";\n}\n\n.fa-address-card-o:before,\n.fa-vcard-o:before {\n  content: \"\\f2bc\";\n}\n\n.fa-user-circle:before {\n  content: \"\\f2bd\";\n}\n\n.fa-user-circle-o:before {\n  content: \"\\f2be\";\n}\n\n.fa-user-o:before {\n  content: \"\\f2c0\";\n}\n\n.fa-id-badge:before {\n  content: \"\\f2c1\";\n}\n\n.fa-drivers-license:before,\n.fa-id-card:before {\n  content: \"\\f2c2\";\n}\n\n.fa-drivers-license-o:before,\n.fa-id-card-o:before {\n  content: \"\\f2c3\";\n}\n\n.fa-quora:before {\n  content: \"\\f2c4\";\n}\n\n.fa-free-code-camp:before {\n  content: \"\\f2c5\";\n}\n\n.fa-telegram:before {\n  content: \"\\f2c6\";\n}\n\n.fa-thermometer-4:before,\n.fa-thermometer-full:before,\n.fa-thermometer:before {\n  content: \"\\f2c7\";\n}\n\n.fa-thermometer-3:before,\n.fa-thermometer-three-quarters:before {\n  content: \"\\f2c8\";\n}\n\n.fa-thermometer-2:before,\n.fa-thermometer-half:before {\n  content: \"\\f2c9\";\n}\n\n.fa-thermometer-1:before,\n.fa-thermometer-quarter:before {\n  content: \"\\f2ca\";\n}\n\n.fa-thermometer-0:before,\n.fa-thermometer-empty:before {\n  content: \"\\f2cb\";\n}\n\n.fa-shower:before {\n  content: \"\\f2cc\";\n}\n\n.fa-bath:before,\n.fa-bathtub:before,\n.fa-s15:before {\n  content: \"\\f2cd\";\n}\n\n.fa-podcast:before {\n  content: \"\\f2ce\";\n}\n\n.fa-window-maximize:before {\n  content: \"\\f2d0\";\n}\n\n.fa-window-minimize:before {\n  content: \"\\f2d1\";\n}\n\n.fa-window-restore:before {\n  content: \"\\f2d2\";\n}\n\n.fa-times-rectangle:before,\n.fa-window-close:before {\n  content: \"\\f2d3\";\n}\n\n.fa-times-rectangle-o:before,\n.fa-window-close-o:before {\n  content: \"\\f2d4\";\n}\n\n.fa-bandcamp:before {\n  content: \"\\f2d5\";\n}\n\n.fa-grav:before {\n  content: \"\\f2d6\";\n}\n\n.fa-etsy:before {\n  content: \"\\f2d7\";\n}\n\n.fa-imdb:before {\n  content: \"\\f2d8\";\n}\n\n.fa-ravelry:before {\n  content: \"\\f2d9\";\n}\n\n.fa-eercast:before {\n  content: \"\\f2da\";\n}\n\n.fa-microchip:before {\n  content: \"\\f2db\";\n}\n\n.fa-snowflake-o:before {\n  content: \"\\f2dc\";\n}\n\n.fa-superpowers:before {\n  content: \"\\f2dd\";\n}\n\n.fa-wpexplorer:before {\n  content: \"\\f2de\";\n}\n\n.fa-meetup:before {\n  content: \"\\f2e0\";\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
